import { dispatch } from "@rematch/core";
import { push } from "react-router-redux";
import generateObjectId from "../../helpers/generate-objectid";
import axios from 'axios'

import {
  practicesService,
  practicesSummaryService,
  categoriesService,
  categoryTreeService,
  categoryPublicTreeService,
  serachUsersService,
  activitiesService,
  communitiesService,
  publishedActivitiesService,
  practiceExportService,
  importPracticesService,
  invitesService,
  mailsenderService,
  duplicateActivityService,
  playbookDependenciesService,
  playbookCopyService,
  playbookVersionService,
  practiceExcelExportService,
  PracticeActivitySummaryService,
  publicPlayboooksService,
  practiceWordExportService,
  practiceTemplateDownloadService,
  decodePracticesService,
  playbookMetadataService,
  SERVER_INDEXING_URL,
  dataProcessorImageService,
  dataProcessorDescriptionService,
  dataProcessorRolesService,
  dataProcessorStageService,
  dataProcessorLeafNodeActivitiesService,
  dataProcessorWebSearchService,
  dataProcessorActivitiesService,
  dataProcessorAllWebSearchService,
  customTemplateActionService,
  activityActionsService,
  makeAllScenariosService,
  GetScenarioInputs,
  subOrganizationTreeService,
  entityFieldMappingService,
  dataProcessorPlaybookNameService
} from "../../services/feathers.service";
import { toastr } from "react-redux-toastr";
import _, { filter } from "lodash";
const Graph = require("graph.js/dist/graph.full.js");
const initialState = {
  allList: [],
  treeNode: {},
  practiceLibraryArr: [],
  showResourecePaneFlag: null,
  selectedPracticeLibrary: {},
  baseCategoriesArr: [],
  categoriesArr: [],
  subCategoriesArr: [],
  scope: "Private",
  categoryTree: [],
  categoryPublicTree: [],
  imageObjectCloudinary: null,
  packArray: [],
  showLandingPageFlag: true,
  setUpdatedImageName: "",
  setDafaultImage: null,
  isModalOpen: false,
  generatedPlaybookName:"",
  searchUserArr: [],
  userSearchObject: {
    firstName: "",
    lastName: "",
    email: "",
  },
  arrangementPaneFlag: false,
  arrangementPaneActiveButtonFlag: null,
  libraryCardIndex: null,
  participantsData: [],
  packCount: {},
  breadcrumbs: {
    key: "",
    content: "",
    link: true,
  },
  activity: {},
  isEditModalOpen: false,
  isRoleChangeModalOpen: false,
  isCreatePracticeCard: false,
  practiceLabelName: "Playbook Development",
  displaySecondMenu: null,
  activityList: [],
  isDragable: null,
  invitedUsersArray: [],
  playbookToExport: {},
  playbookInvitaions: [],
  searchInviteUserArr: [],
  playbookImagesBuffer:[],
  playbookSearchQuery:"",
  isPlaybookInvitationModalOpen: false,
  enableLinkActivity: false,
  routeParams: {},
  playbookStatus: null,
  enableDependencyIcon: false,
  validPracticeName: false,
  setUniqueId: null,
  splitAtSize: null,
  isPlaybookImported: false,
  graph: new Graph(),
  playbookError: null,
  activePageTab: null,
  currentNote: {},
  allPlaybooksByUserIdAndTeamId: [],
  sortingFlag: { key: "createdAt", order: 1, text: "CreatedAt" },
  currentPathValue: 0,
  playbookTimeStamp: "",
  activitySummary: [],
  singleActivityDetail: {},
  currentPlaybookTemplate: {},
  decodedPlaybook: null,
  publishActivityCountByCategory: null,
  singlePlaybookEntry: {},
  allPlaybooksFromBaseId: [],
  filterByStatus:[],
  playbook: null,
  playbookGenerationState: null,
  playbookGenerationIndex: 0,
  selectedTreeId: 11,
  percentageGenerationComplete:null,
  percentageActivitesGenerated:null,
  customEmailTemplates: [],
  scenarios: [],
  scenarioInputs: [],
  activityActions: [],
  entities: [],
  teamList: [],
  entityFieldMapping: []
};
export default {
  state: initialState,
  reducers: {
    setError(state, payload) {
      return {
        ...state,
        subOrgError: payload,
      };
    },
    setTreeNode(state, payload) {
      return {
        ...state,
        treeNode: payload,
      };
    },
    setPlaybookGenerationState(state,payload){
      return {
        ...state,
        playbookGenerationState:payload,
      }
    },
    setPercentageGenerationComplete(state,payload){
      return {
        ...state,
        percentageGenerationComplete:payload,
      }
    },
    setSelectedTreeId(state,payload){
      return {
        ...state,
        selectedTreeId:payload,
      }
    },
    setPercentageActivitiesGenerated(state,payload){
      return {
        ...state,
        percentageActivitesGenerated:payload,
      }
    },
    setPlaybookGenerationIndex(state,payload){
      return {
        ...state,
        playbookGenerationIndex:payload,
      }
    },
    setPlaybookImagesBuffer(state,payload){
      return {
        ...state,
        playbookImagesBuffer:payload
      }
    },
    setPlaybook(state,payload){
      return {
        ...state,
        playbook:payload,
      }
    },
    setPracticeLibrary(state, payload) {
      return {
        ...state,
        practiceLibraryArr: payload,
      };
    },
    setFilterByStatus(state, payload) {
      return {
        ...state,
        filterByStatus: payload,
      };
    },
    setSelectedPracticeLibraryData(state, payload = {}) {
      if (payload.activities) {
        let sequenceViewMap = new Map();
        payload.activities.forEach((phase) => {
          sequenceViewMap.set(phase._id, phase);
          if (phase.activities) {
            phase.activities.forEach((stage) => {
              sequenceViewMap.set(stage._id, stage);
              if (stage.activities) {
                stage.activities.forEach((activity) => {
                  sequenceViewMap.set(activity._id, activity);
                });
              }
            });
          }
        });
        payload.sequenceViewMap = sequenceViewMap;
      }
      return {
        ...state,
        selectedPracticeLibrary: payload,
        playbookTimeStamp: payload.updatedAt,
      };
    },
    showResourecePaneFlagSet(state, payload) {
      return {
        ...state,
        showResourecePaneFlag: payload,
      };
    },
    setArrangementPaneFlag(state, payload) {
      return {
        ...state,
        arrangementPaneFlag: payload,
      };
    },
    setArrangementPaneActiveButtonFlag(state, payload) {
      return {
        ...state,
        arrangementPaneActiveButtonFlag: payload,
      };
    },

    showResourecePaneWidthSet(state, payload) {
      return {
        ...state,
        showResourecePaneSetWidth: payload,
      };
    },
    setBaseCategory(state, payload) {
      return {
        ...state,
        baseCategoriesArr: payload,
      };
    },
    setCategory(state, payload = []) {
      return {
        ...state,
        categoriesArr: payload,
      };
    },
    setSubCategory(state, payload = []) {
      return {
        ...state,
        subCategoriesArr: payload,
      };
    },
    setcategoryTree(state, payload = []) {
      return {
        ...state,
        categoryTree: payload,
      };
    },
    setcategoryPublicTree(state, payload = []) {
      return {
        ...state,
        categoryPublicTree: payload,
      };
    },
    setScope(state, payload) {
      return {
        ...state,
        scope: payload,
      };
    },
    setImageUploadData(state, payload = {}) {
      return {
        ...state,
        imageObjectCloudinary: payload,
      };
    },
    setPackList(state, payload = []) {
      return {
        ...state,
        packArray: payload,
      };
    },
    setAllList(state, payload = []) {
      return {
        ...state,
        allList: payload,
      };
    },
    showLandingPageFlagSet(state, payload) {
      return {
        ...state,
        showLandingPageFlag: payload,
      };
    },
    editCardImage(state, payload) {
      return {
        ...state,
        setUpdatedImageName: payload,
      };
    },
    setDefaultImageData(state, payload) {
      return {
        ...state,
        setDafaultImage: payload,
      };
    },
    setModalOpen(state, payload) {
      return {
        ...state,
        isModalOpen: payload,
      };
    },
    setSearchUser(state, payload) {
      return {
        ...state,
        searchUserArr: payload,
      };
    },
    clearSearchFilter(state, payload) {
      return {
        ...state,
        userSearchObject: payload,
      };
    },
    setLibraryCardIndex(state, payload) {
      return {
        ...state,
        libraryCardIndex: payload,
      };
    },
    addTags(state, payload) {
      return {
        ...state,
        selectedPracticeLibrary: {
          ...state.selectedPracticeLibrary,
          tags: [...state.selectedPracticeLibrary.tags, payload],
        },
      };
    },
    removeTags(state, payload) {
      return {
        ...state,
        selectedPracticeLibrary: {
          ...state.selectedPracticeLibrary,
          tags: [
            ...state.selectedPracticeLibrary.tags.slice(0, payload),
            ...state.selectedPracticeLibrary.tags.slice(payload + 1),
          ],
        },
      };
    },
    setParticipants(state, payload = []) {
      return {
        ...state,
        participantsData: payload,
      };
    },
    setDeleteParticipants(state, payload) {
      return {
        ...state,
        participantsData: [
          ...state.participantsData.slice(0, payload),
          ...state.participantsData.slice(payload + 1),
        ],
      };
    },
    setPackCount(state, payload) {
      return {
        ...state,
        packCount: payload,
      };
    },
    setSelectedPracticeLibraryDataAfterCreation(state, payload) {
      return {
        ...state,
        selectedPracticeLibrary: state.packArray.filter((pack) => {
          return pack._id === payload;
        })[0],
      };
    },
    setBreadCrumbs(state, payload) {
      return {
        ...state,
        breadcrumbs: payload,
      };
    },

    setEditModalOpen(state, payload) {
      return {
        ...state,
        isEditModalOpen: payload,
      };
    },
    setRoleChangeModalOpen(state, payload) {
      return {
        ...state,
        isRoleChangeModalOpen: payload,
      };
    },
    setCreatePracticeCard(state, payload) {
      return {
        ...state,
        isCreatePracticeCard: payload,
      };
    },
    preparePracticeToMoveInDesign(state, payload) {
      return {
        ...state,
        selectedPracticeLibrary: {
          ...state.selectedPracticeLibrary,
          reviewHistory: [
            ...state.selectedPracticeLibrary.reviewHistory,
            ...payload,
          ],
        },
      };
    },
    displaySecondMenuFlagSet(state, payload) {
      return {
        ...state,
        displaySecondMenu: payload,
      };
    },
    storeActivities(state, payload) {
      return {
        ...state,
        activityList: payload,
      };
    },
    setGeneratedPlaybookName(state, payload) {
      return {
        ...state,
        generatedPlaybookName: payload,
      };
    },
    setIsDragable(state, payload) {
      return {
        ...state,
        isDragable: payload,
      };
    },
    setInvitedParticipantData(state, payload = []) {
      return {
        ...state,
        invitedUsersArray: payload,
      };
    },
    getPlaybookDataToExport(state, payload = {}) {
      return {
        ...state,
        playbookToExport: payload,
      };
    },
    setInvitaionInsidePlaybook(state, payload = []) {
      return {
        ...state,
        playbookInvitaions: payload,
      };
    },
    setSearchInviteUser(state, payload) {
      return {
        ...state,
        searchInviteUserArr: payload,
      };
    },
    setDeleteInviteUser(state, payload) {
      return {
        ...state,
        invitedUsersArray: [
          ...state.invitedUsersArray.slice(0, payload),
          ...state.invitedUsersArray.slice(payload + 1),
        ],
      };
    },
    resendAndDeleteInviteModalOpen(state, payload) {
      return {
        ...state,
        isPlaybookInvitationModalOpen: payload,
      };
    },
    enableLinking(state, payload) {
      return {
        ...state,
        enableLinkActivity: true,
      };
    },
    disableLinking(state, payload) {
      return {
        ...state,
        enableLinkActivity: false,
      };
    },
    setDependencyIcon(state, payload) {
      return {
        ...state,
        enableDependencyIcon: payload,
      };
    },
    addRoutParams(state, payload) {
      return {
        ...state,
        routeParams: payload,
      };
    },
    setInitStatus(state, payload) {
      return {
        ...state,
        playbookStatus: payload,
      };
    },
    isPracticeAvailable(state, payload) {
      return {
        ...state,
        validPracticeName: payload,
      };
    },
    setDBUniqueId(state, payload) {
      return {
        ...state,
        setUniqueId: payload,
      };
    },
    setSplitAtSize(state, payload) {
      return {
        ...state,
        splitAtSize: payload,
      };
    },
    isPlaybookImportLoading(state, payload) {
      return {
        ...state,
        isPlaybookImported: payload,
      };
    },
    setGraph(state, payload) {
      return {
        ...state,
        graph: payload,
      };
    },
    setEventBus(state, payload) {
      return {
        ...state,
        eventBus: payload,
      };
    },
    setCommunityEventBus(state, payload) {
      return {
        ...state,
        communityEventBus: payload,
      };
    },
    setActivePage(state, payload) {
      return {
        ...state,
        activePageTab: payload,
      };
    },
    setPlaybookSearchQuery(state, payload) {
      return {
        ...state,
        playbookSearchQuery: payload,
      };
    },
    setPlaybookError(state, payload) {
      return {
        ...state,
        playbookError: payload,
      };
    },
    addPlaybookToPackList(state, payload) {
      return {
        ...state,
        packArray: [...state.packArray, payload],
      };
    },
    removePlaybookFromPackList(state, payload) {
      return {
        ...state,
        packArray: [
          ...state.packArray.slice(0, payload),
          ...state.packArray.slice(payload + 1),
        ],
      };
    },
    setCurrntNotesData(state, payload) {
      return {
        ...state,
        currentNote: payload,
      };
    },
    setPlaybooksByUserIdAndTeamId(state, payload) {
      return {
        ...state,
        allPlaybooksByUserIdAndTeamId: payload,
      };
    },
    isSortingFlag(state, payload) {
      return {
        ...state,
        sortingFlag: payload,
      };
    },
    treeCurrentPath(state, payload) {
      return {
        ...state,
        currentPathValue: payload,
      };
    },
    setTimeStamp(state, payload) {
      return {
        ...state,
        playbookTimeStamp: payload,
      };
    },
    setActivitySummary(state, payload) {
      return {
        ...state,
        activitySummary: payload,
      };
    },
    setSingleActivity(state, payload) {
      return {
        ...state,
        singleActivityDetail: payload,
      };
    },
    setCurrentPlaybookTemplate(state, payload) {
      return {
        ...state,
        currentPlaybookTemplate: payload,
      };
    },
    setDecodedPlaybook(state, payload) {
      return {
        ...state,
        decodedPlaybook: payload,
      };
    },
    setPublishActivityCountByCategory(state, payload) {
      return {
        ...state,
        publishActivityCountByCategory: payload,
      };
    },

    setSinglePlaybookData(state, payload) {
      return {
        ...state,
        singlePlaybookEntry: payload,
      };
    },
    allRetrievedPlaybooksBasedOnBaseId(state, payload) {
      return {
        ...state,
        allPlaybooksFromBaseId: payload,
      };
    },

    clear() {
      return initialState;
    },
    setCustomEmailTemplates(state, payload) {
      return {
        ...state,
        customEmailTemplates: payload,
      };
    },
    setMakeScenarios(state, payload) {
      return {
        ...state,
        scenarios: payload,
      };
    },
    setMakeEntities(state, payload) {
      return {
        ...state,
        entities: payload,
      };
    },
    setEntityFieldMapping(state, payload) {
      return {
        ...state,
        entityFieldMapping: payload,
      };
    },
    setScenarioInputs(state, payload) {
      return {
        ...state,
        scenarioInputs: payload,
      };
    },
    setTeamList(state, payload) {
      return {
        ...state,
        teamList: payload,
      };
    },
  },
  effects: {
    async addNewPracticeAsync(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        payload.slug = payload.slug.toLowerCase().trim();
        const addNewPractice = await practicesService.create(payload, {
          query: {
            $populate: [
              {
                path: "participants.accountUserId",
                populate: "accountUserId",
                select: "_id firstName lastName profilePic email",
              },
              {
                path: "notes.accountUserId",
                populate: "accountUserId",
                select: "_id firstName lastName profilePic email ",
              },
              {
                path: "attachments.uploadedBy",
                populate: "uploadedBy",
                select: "_id firstName lastName profilePic ",
              },
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          },
        });
        toastr.success(
          "Message",
          payload.name + " playbook added successfully"
        );
        await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(
          addNewPractice._id
        );
        dispatch.lifeCycle.setArrangementPaneActiveButtonFlag(1);
        dispatch.lifeCycle.getCounts({ id: addNewPractice.organizationId });

        return dispatch(
          push(
            `/app/${addNewPractice.accountId}/_ws/${addNewPractice.organizationId}/_pb/steps/${addNewPractice._id}/configure`
          )
        );
      } catch (err) {
        throw err;
      }
    },
    async addNewPlaybookToPackList(payload, state) {
      if (
        !state.app.playbookPath ||
        (state.app.playbookPath &&
          (state.app.playbookPath.includes("In Design") ||
            state.app.playbookPath.includes("playbookLibrary") ||
            (state.app.playbookPath.includes("knowledgeBank") &&
              payload.scope === "Private") ||
            (state.app.playbookPath.includes("publicKnowledgeBank") &&
              payload.scope === "Public")) &&
          state.app.currentContext === "designer" &&
          state.app.selectedOrganisation &&
          state.app.selectedOrganisation.id &&
          state.app.selectedOrganisation.id.toString() ===
            payload.organizationId.toString())
      ) {
        let packData = Object.assign({}, payload);
        const indexOfPlaybook = (packsArray, newPlaybook) => {
          for (let [i, playbook] of packsArray.entries()) {
            if (playbook._id.toString() === newPlaybook._id.toString()) {
              return i;
            }
          }
          return -1;
        };
        let isParticipant = false;
        if (packData.participants) {
          packData.participants.forEach((participant) => {
            const participantId = participant.accountUserId._id
              ? participant.accountUserId._id
              : participant.accountUserId;
            if (participantId.toString() === state.app.user._id.toString()) {
              if (
                (packData.status !== 4 &&
                  packData.status !== 1 &&
                  participant.role !== "reviewer") ||
                packData.status === 1
              ) {
                isParticipant = true;
              }
            }
          });
          if (
            !isParticipant &&
            state.app.selectedOrganisation.role === "workspaceOwner"
          ) {
            isParticipant = true;
          }
          if (isParticipant) {
            if (
              state.lifeCycle.packArray &&
              indexOfPlaybook(state.lifeCycle.packArray, packData) === -1
            ) {
              dispatch.lifeCycle.addPlaybookToPackList(packData);
            }
          } else if (
            state.lifeCycle.selectedPracticeLibrary &&
            (state.lifeCycle.selectedPracticeLibrary.status == 2 ||
              state.lifeCycle.selectedPracticeLibrary.status == 4)
          ) {
          } else {
            if (
              state.lifeCycle.packArray &&
              indexOfPlaybook(state.lifeCycle.packArray, packData) !== -1
            ) {
              dispatch.lifeCycle.removePlaybookFromPackList(
                indexOfPlaybook(state.lifeCycle.packArray, packData)
              );
              if (
                state.lifeCycle.selectedPracticeLibrary &&
                state.lifeCycle.selectedPracticeLibrary._id &&
                state.lifeCycle.selectedPracticeLibrary._id.toString() ===
                  payload._id.toString()
              ) {
                await dispatch.lifeCycle.setSelectedPracticeLibraryData({});
                await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
                await dispatch.lifeCycle.showResourecePane(null);
                dispatch.lifeCycle.setArrangementPaneFlag(false);
                return dispatch(
                  push(
                    `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_pb`
                  )
                );
              }
            }
          }
        }
      }
    },
    async searchPracticeByName(payload) {
      let searchQuery = {};
      // searchQuery.name = payload.name.toLowerCase();
      searchQuery.name = { $regex: payload.name.toLowerCase(), $options: "i" };
      searchQuery.organizationId = payload.organisationId;
      let searchedPractice = await practicesService.find({
        query: searchQuery,
      });
      if (searchedPractice.length > 0) {
        dispatch.lifeCycle.isPracticeAvailable(true);
      } else {
        dispatch.lifeCycle.isPracticeAvailable(false);
      }
    },

    showResourecePane(payload) {
      dispatch.lifeCycle.showResourecePaneFlagSet(payload);
      return;
    },
    showResourecePaneWidth(payload) {
      dispatch.lifeCycle.showResourecePaneWidthSet(payload);
    },

    setSelectedPracticeLibrary(payload) {
      dispatch.lifeCycle.setSelectedPracticeLibraryData(payload);
    },
    async getCategoryAsync(payload, state) {
      dispatch.lifeCycle.getCategoryTreeAsync(payload);
      return;
      if (state.app.selectedAccount._id && payload.accountId) {
        if (
          payload.accountId.toString() ===
          state.app.selectedAccount._id.toString()
        ) {
          try {
            dispatch.lifeCycle.setError(null);
            let kb = await categoriesService.find({
              query: {
                ...payload,
              },
            });

            if (kb && kb.data && kb.data.length !== 0) {
              for (let i = 0; i < kb.data.length; i++) {
                kb.data[i].id = kb.data[i]._id;
                kb.data[i].text = kb.data[i].name;
                kb.data[i].value = kb.data[i].name;
                if (
                  kb.data[i].categories &&
                  kb.data[i].categories.length !== 0
                ) {
                  for (let j = 0; j < kb.data[i].categories.length; j++) {
                    kb.data[i].categories[j].id = kb.data[i].categories[j]._id;
                    kb.data[i].categories[j].text =
                      kb.data[i].categories[j].name;
                    kb.data[i].categories[j].value =
                      kb.data[i].categories[j].name;
                    if (
                      kb.data[i].categories[j].subCategories &&
                      kb.data[i].categories[j].subCategories.length !== 0
                    ) {
                      kb.data[i].categories[j].subCategories.push({
                        id: i + "_" + j,
                        name: "Others",
                      });
                      for (
                        let k = 0;
                        k < kb.data[i].categories[j].subCategories.length;
                        k++
                      ) {
                        kb.data[i].categories[j].subCategories[k].id =
                          kb.data[i].categories[j].subCategories[k]._id;
                        kb.data[i].categories[j].subCategories[k].text =
                          kb.data[i].categories[j].subCategories[k].name;
                        kb.data[i].categories[j].subCategories[k].value =
                          kb.data[i].categories[j].subCategories[k].name;
                      }
                    }
                  }
                }
              }
            }
            // dispatch.lifeCycle.setBaseCategory(kb);
          } catch (err) {
            dispatch.lifeCycle.setError(err);
            toastr.error("Message", "Failed to get category ");
            throw err;
          }
        }
      }
    },
    async getCategoryTreeAsync(payload, state) {
      try {
        dispatch.lifeCycle.setError(null);

        // Get Category Tree
        let cT = await categoryTreeService.find({
          query: {
            accountId: payload
              ? payload.accountId
              : state.app.selectedAccount._id,
          },
          accountOnly: payload && payload.accountOnly ? true : false,
        });
        // Alpha numeric Function
        var collator = new Intl.Collator(undefined, {
          numeric: true,
          sensitivity: "base",
        });
        cT =
          cT && cT.length !== 0
            ? cT &&
              cT.length !== 0 &&
              cT.sort((a, b) => {
                return collator.compare(a.name, b.name);
              })
            : [];

        for (let i = 0; i < cT.length; i++) {
          if (cT[i].nodes && cT[i].nodes.length !== 0) {
            cT[i].nodes &&
              cT[i].nodes.length !== 0 &&
              cT[i].nodes.sort((a, b) => {
                return a && b && collator.compare(a.name, b.name);
              });
            for (let j = 0; j < cT[i].nodes.length; j++) {
              if (cT[i].nodes[j].nodes && cT[i].nodes[j].nodes.length > 0) {
                cT[i].nodes[j].nodes.sort((a, b) => {
                  return a && b && collator.compare(a.name, b.name);
                });
              }
            }
          }
        }
        await dispatch.lifeCycle.setBaseCategory(cT);
        await dispatch.lifeCycle.setcategoryTree(cT);
        await dispatch.content.setBasecategory(cT);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Failed to get category ");
        throw err;
      }
    },
    async getPublicCategoryTreeAsync(payload, state) {
      try {
        dispatch.lifeCycle.setError(null);

        // Get Category Tree
        let cT = await categoryPublicTreeService.find({
          query: {
            isPublic: true,
            orgId: state.app.selectedOrganisation.id,
            role: state.app.selectedOrganisation.role,
          },
        });

        // Alpha numeric Function
        var collator = new Intl.Collator(undefined, {
          numeric: true,
          sensitivity: "base",
        });

        cT && cT.length !== 0
          ? cT.sort((a, b) => {
              return collator.compare(a.name, b.name);
            })
          : [];

        for (let i = 0; i < cT.length; i++) {
          if (cT[i].nodes && cT[i].nodes.length !== 0) {
            for (let j = 0; j < cT[i].nodes.length; j++) {
              cT[i].nodes.sort((a, b) => {
                return collator.compare(a.name, b.name);
              });
              if (cT[i].nodes[j].nodes && cT[i].nodes[j].nodes.length !== 0) {
                for (let k = 0; k < cT[i].nodes[j].nodes.length; k++) {
                  cT[i].nodes[j].nodes && cT[i].nodes[j].nodes.length !== 0
                    ? cT[i].nodes[j].nodes.sort((a, b) => {
                        return collator.compare(a.name, b.name);
                      })
                    : null;
                }
              }
            }
          }
        }

        dispatch.lifeCycle.setcategoryPublicTree(cT);
        dispatch.app.setPublicBasecategory(cT);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Failed to get category ");
        throw err;
      }
    },
    setCategoryAsync(payload) {
      dispatch.lifeCycle.setCategory(payload);
    },
    setSubCategoryAsync(payload) {
      dispatch.lifeCycle.setSubCategory(payload);
    },
    setScopeAsync(payload) {
      dispatch.lifeCycle.setScope(payload);
    },
    setCardImageAsync(payload) {
      dispatch.lifeCycle.setImageUploadData(payload);
    },
    updateEditCardImageAsync(payload) {
      dispatch.lifeCycle.editCardImage(payload);
    },
    setDefaultCardImageAsync(payload) {
      dispatch.lifeCycle.setDefaultImageData(payload);
    },

    clearAsync() {
      dispatch.lifeCycle.clear();
    },
    async getPacksAsync(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        if (payload.role === "workspaceOwner") {
          let query = {
            $and: [{ organizationId: payload.organizationId },   //KLM-9349
              {
                participants: {
                  $elemMatch: {
                    accountUserId: payload.user._id,
                    role: ["author", "contributor"],
                  },
                },
              }
            ],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          };

          if (payload.$sort) {
            query.$sort = payload.$sort;
          } else {
            query.$sort = { createdAt: -1 };
          }
          const Packdata = await practicesService.find({
            query: query,
          });
          dispatch.lifeCycle.setPackList(Packdata);
        } else if (payload.role === "Manager" || payload.role === "Member") {
          let query = {
            $and: [
              { organizationId: payload.organizationId },
              {
                $or: [
                  {
                    $and: [
                      { status: 0 },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: payload.user._id,
                            role: ["author", "contributor"],
                          },
                        },
                      },
                    ],
                  },
                  {
                    $and: [
                      { status: [1, 2] },
                      {
                        participants: {
                          $elemMatch: { accountUserId: payload.user._id },
                        },
                      },
                    ],
                  },
                  {
                    $and: [
                      { status: 4 },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: payload.user._id,
                            role: "author",
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          };

          if (payload.$sort) {
            query.$sort = payload.$sort;
          }
          const Packdata = await practicesService.find({
            query: query,
          });

          dispatch.lifeCycle.setPackList(Packdata);
        }

        if (payload.sortBy && payload.sortBy.key) {
          dispatch.lifeCycle.isSortingFlag(payload.sortBy);
        }
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "failed to get playbooks");
        throw err;
      }
    },
    async getAllListAsync(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        if (payload.role === "workspaceOwner") {
          let query = {
            $and: [{ organizationId: payload.organizationId }],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          };

          if (payload.$sort) {
            query.$sort = payload.$sort;
          } else {
            query.$sort = { createdAt: -1 };
          }
          const Packdata = await practicesService.find({
            query: query,
          });
          dispatch.lifeCycle.setAllList(Packdata);
        } else if (payload.role === "Manager" || payload.role === "Member") {
          let query = {
            $and: [
              { organizationId: payload.organizationId },
              {
                $or: [
                  {
                    $and: [
                      { status: 0 },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: payload.user._id,
                            role: ["author", "contributor"],
                          },
                        },
                      },
                    ],
                  },
                  {
                    $and: [
                      { status: [1, 2] },
                      {
                        participants: {
                          $elemMatch: { accountUserId: payload.user._id },
                        },
                      },
                    ],
                  },
                  {
                    $and: [
                      { status: 4 },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: payload.user._id,
                            role: "author",
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          };

          if (payload.$sort) {
            query.$sort = payload.$sort;
          }
          const Packdata = await practicesService.find({
            query: query,
          });
          dispatch.lifeCycle.setAllList(Packdata);
        }

        if (payload.sortBy && payload.sortBy.key) {
          dispatch.lifeCycle.isSortingFlag(payload.sortBy);
        }
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "failed to get playbooks");
        throw err;
      }
    },
    async editPackAsync(payload, state) {
      const editPack = payload.selectedPack;
      try {
        await practicesService.patch(
          editPack._id,
          editPack,
          {
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
        dispatch.lifeCycle.updatePacksList({
          _id: editPack._id,
          data: { name: editPack.name },
        });
        dispatch.lifeCycle.getInviteByPackIdAsync(editPack._id);
        dispatch.lifeCycle.setPlaybookError(null);
      } catch (err) {
        let errMessage = null;
        if (err.message.indexOf("already exists") !== -1) {
          errMessage = "Playbook with same name already exists.";
        } else {
          errMessage = "Error while updating playbook.";
          toastr.error("Message", errMessage);
        }
        dispatch.lifeCycle.setPlaybookError(errMessage);
        throw err;
      }
    },
    async updatePlaybookPicture(payload, state) {
      try {
        await practicesService.patch(
          payload._id,
          { picture: payload.picture },
          {
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
      } catch (err) {
        throw err;
      }
    },
    showLangingPage(payload) {
      dispatch.lifeCycle.showLandingPageFlagSet(payload);
    },
    modalOpen(onOffState) {
      dispatch.lifeCycle.setModalOpen(onOffState);
    },
    modalEditOpen(onOffState) {
      dispatch.lifeCycle.setEditModalOpen(onOffState);
    },
    async getSearchedUsers(payload) {
      if (payload.value) {
        try {
          let searchedUsersData;

          searchedUsersData = await serachUsersService.find({
            query: payload,
          });
          dispatch.lifeCycle.setSearchUser(searchedUsersData.userResult);
          dispatch.lifeCycle.setSearchInviteUser(
            searchedUsersData.inviteResult
          );
        } catch (err) {
          dispatch.lifeCycle.setError(err);
        }
      }
    },
    clearContributorSearchFilter() {
      let userSearchObject = {
        firstName: "",
        lastName: "",
        email: "",
      };
      dispatch.lifeCycle.clearSearchFilter(userSearchObject);
      dispatch.lifeCycle.setSearchUser([]);
      dispatch.lifeCycle.setSearchInviteUser([]);
    },
    updateArrangementFlag(payload) {
      dispatch.lifeCycle.setArrangementPaneFlag(payload);
    },
    updateArrangementPaneActiveButtonFlag(payload) {
      dispatch.lifeCycle.setArrangementPaneActiveButtonFlag(payload);
    },
    updateLibraryCardIndex(payload) {
      dispatch.lifeCycle.setLibraryCardIndex(payload);
    },
    setParticipantsAsync(payload) {
      dispatch.lifeCycle.setParticipants(payload);
    },
    addTag(payload) {
      dispatch.lifeCycle.addTags(payload);
    },
    removeTag(payload) {
      dispatch.lifeCycle.removeTags(payload);
    },

    async getPacksByStatus(payload) {
      let filterData = payload;
      let query;

      query = {
        $and: [
          { organizationId: filterData.organizationId },
          { status: filterData.status },
        ],
        $populate: [
          {
            path: "baseCategory",
            populate: "baseCategory",
            select: "_id name",
          },
          { path: "category", populate: "category", select: "_id name" },
          { path: "subCategory", populate: "subCategory", select: "_id name" },
        ],
        $sort: { createdAt: -1 },
      };
      if (payload.$sort) {
        query.$sort = payload.$sort;
      } else {
        query.$sort = { createdAt: -1 };
      }

      if (filterData.status === 0) {
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $ne: "reviewer" },
            },
          },
        });
      }
      if (
        filterData.status === 1 ||
        filterData.status === 2 ||
        filterData.status === 3
      ) {
        query.$and.push({
          participants: {
            $elemMatch: { accountUserId: filterData.accountUserId },
          },
        });
      }
      if (filterData.status === 4) {
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $eq: "author" },
            },
          },
        });
      }
      if (filterData.status === 5) {
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $eq: "author" },
            },
          },
        });
      }
      try {
        dispatch.lifeCycle.setError(null);
        const Packdata = await practicesService.find({
          query: query,
        });
        dispatch.lifeCycle.setPackList(Packdata);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "failed to get playbooks");
        throw err;
      }
    },
    async getAllPacksByBaseCategory(payload, state) {
      try {
        dispatch.lifeCycle.setError(null);
        // Below changes for KLM-8964
        if (payload.role === "workspaceOwner") {
          let query = {
            scope: "Public",
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          };
          let KBPlaybook;
          if (query.scope === "Public" || payload.scope === "Public") {
            query.scope = "Public";
            KBPlaybook = await publicPlayboooksService.find({
              query: query,
            });
          }
          if (query.scope === "Private" || payload.scope === "Private") {
            query.scope = "Private";
            query.organizationId = payload.organizationId;
            KBPlaybook = await practicesService.find({
              query: query,
            });
          }

          dispatch.lifeCycle.setPackList(KBPlaybook);
        } else if (payload.role === "Manager" || payload.role === "Member") {
          let query = {
            scope: "Public",
            $and: [
              { organizationId: payload.organizationId },
              {
                $or: [
                  {
                    $and: [
                      { status: 0 },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: payload.user._id,
                            role: ["author", "contributor"],
                          },
                        },
                      },
                    ],
                  },
                  {
                    $and: [
                      { status: [1, 2] },
                      {
                        participants: {
                          $elemMatch: { accountUserId: payload.user._id },
                        },
                      },
                    ],
                  },
                  {
                    $and: [
                      { status: 4 },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: payload.user._id,
                            role: "author",
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          };

          let KBPlaybook;
          if (query.scope === "Public" || payload.scope === "Public") {
            query.scope = "Public";
            KBPlaybook = await publicPlayboooksService.find({
              query: query,
            });
          }
          if (query.scope === "Private" || payload.scope === "Private") {
            query.scope = "Private";
            query.organizationId = payload.organizationId;
            KBPlaybook = await practicesService.find({
              query: query,
            });
          }

          dispatch.lifeCycle.setPackList(KBPlaybook);
        }
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "failed to get playbook");
        throw err;
      }
    },
    async getPacksByBaseCategory(payload) {
      try {
        // Below changes for KLM-8964
        dispatch.lifeCycle.setError(null);
        if (payload.role === "workspaceOwner") {
          let bCPlaybook;
          let query = {
            baseCategory: payload.baseCategory,
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          };
          if (payload.scope === "Public") {
            query.scope = "Public";
            bCPlaybook = await publicPlayboooksService.find({
              query: query,
            });
          }
          if (payload.scope === "Private") {
            query.scope = "Private";
            query.organizationId = payload.organizationId;
            bCPlaybook = await practicesService.find({
              query: query,
            });
          }

          dispatch.lifeCycle.setPackList(bCPlaybook);
        } else if (payload.role === "Manager" || payload.role === "Member") {
          let bCPlaybook;
          let query = {
            baseCategory: payload.baseCategory,
            $and: [
              { organizationId: payload.organizationId },
              {
                $or: [
                  {
                    $and: [
                      { status: 0 },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: payload.user._id,
                            role: ["author", "contributor"],
                          },
                        },
                      },
                    ],
                  },
                  {
                    $and: [
                      { status: [1, 2] },
                      {
                        participants: {
                          $elemMatch: { accountUserId: payload.user._id },
                        },
                      },
                    ],
                  },
                  {
                    $and: [
                      { status: 4 },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: payload.user._id,
                            role: "author",
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          };
          if (payload.scope === "Public") {
            query.scope = "Public";
            bCPlaybook = await publicPlayboooksService.find({
              query: query,
            });
          }
          if (payload.scope === "Private") {
            query.scope = "Private";
            query.organizationId = payload.organizationId;
            bCPlaybook = await practicesService.find({
              query: query,
            });
          }

          dispatch.lifeCycle.setPackList(bCPlaybook);
        }
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "failed to get playbooks");
        throw err;
      }
    },
    async getPacksByCategory(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        if (payload.role === "workspaceOwner") {
        let cPlaybook;
        let query = {
          baseCategory: payload.baseCategory,
          category: payload.category,
          $populate: [
            {
              path: "baseCategory",
              populate: "baseCategory",
              select: "_id name",
            },
            { path: "category", populate: "category", select: "_id name" },
            {
              path: "subCategory",
              populate: "subCategory",
              select: "_id name",
            },
          ],
        };
        if (payload.scope === "Public") {
          query.scope = "Public";
          cPlaybook = await publicPlayboooksService.find({
            query: query,
          });
        }
        if (payload.scope === "Private") {
          query.scope = "Private";
          query.organizationId = payload.organizationId;
          cPlaybook = await practicesService.find({
            query: query,
          });
        }

        dispatch.lifeCycle.setPackList(cPlaybook);
      } else if (payload.role === "Manager" || payload.role === "Member") {
        let cPlaybook;
        let query = {
          baseCategory: payload.baseCategory,
          category: payload.category,
          $and: [
            { organizationId: payload.organizationId },
            {
              $or: [
                {
                  $and: [
                    { status: 0 },
                    {
                      participants: {
                        $elemMatch: {
                          accountUserId: payload.user._id,
                          role: ["author", "contributor"],
                        },
                      },
                    },
                  ],
                },
                {
                  $and: [
                    { status: [1, 2] },
                    {
                      participants: {
                        $elemMatch: { accountUserId: payload.user._id },
                      },
                    },
                  ],
                },
                {
                  $and: [
                    { status: 4 },
                    {
                      participants: {
                        $elemMatch: {
                          accountUserId: payload.user._id,
                          role: "author",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          $populate: [
            {
              path: "baseCategory",
              populate: "baseCategory",
              select: "_id name",
            },
            { path: "category", populate: "category", select: "_id name" },
            {
              path: "subCategory",
              populate: "subCategory",
              select: "_id name",
            },
          ],
        };
        if (payload.scope === "Public") {
          query.scope = "Public";
          cPlaybook = await publicPlayboooksService.find({
            query: query,
          });
        }
        if (payload.scope === "Private") {
          query.scope = "Private";
          query.organizationId = payload.organizationId;
          cPlaybook = await practicesService.find({
            query: query,
          });
        }
        dispatch.lifeCycle.setPackList(cPlaybook);
      }
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "fail to get");
        throw err;
      }
    },
    async getPacksBySubCategory(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        if (payload.role === "workspaceOwner") {
        let sCPlaybook;
        let query = {
          baseCategory: payload.baseCategory,
          category: payload.category,
          $populate: [
            {
              path: "baseCategory",
              populate: "baseCategory",
              select: "_id name",
            },
            { path: "category", populate: "category", select: "_id name" },
            {
              path: "subCategory",
              populate: "subCategory",
              select: "_id name",
            },
          ],
        };
        if (payload.subCategoryArr && payload.subCategory === "Others") {
          query.subCategory = {
            $nin: payload.subCategoryArr,
          };
        } else {
          query.subCategory = payload.subCategory;
        }
        if (payload.scope === "Public") {
          query.scope = "Public";
          sCPlaybook = await publicPlayboooksService.find({
            query: query,
          });
        }
        if (payload.scope === "Private") {
          query.scope = "Private";
          query.organizationId = payload.organizationId;
          sCPlaybook = await practicesService.find({
            query: query,
          });
        }

        dispatch.lifeCycle.setPackList(sCPlaybook);
      } else if (payload.role === "Manager" || payload.role === "Member") {
        let sCPlaybook;
        let query = {
          baseCategory: payload.baseCategory,
          category: payload.category,
          $and: [
            { organizationId: payload.organizationId },
            {
              $or: [
                {
                  $and: [
                    { status: 0 },
                    {
                      participants: {
                        $elemMatch: {
                          accountUserId: payload.user._id,
                          role: ["author", "contributor"],
                        },
                      },
                    },
                  ],
                },
                {
                  $and: [
                    { status: [1, 2] },
                    {
                      participants: {
                        $elemMatch: { accountUserId: payload.user._id },
                      },
                    },
                  ],
                },
                {
                  $and: [
                    { status: 4 },
                    {
                      participants: {
                        $elemMatch: {
                          accountUserId: payload.user._id,
                          role: "author",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          $populate: [
            {
              path: "baseCategory",
              populate: "baseCategory",
              select: "_id name",
            },
            { path: "category", populate: "category", select: "_id name" },
            {
              path: "subCategory",
              populate: "subCategory",
              select: "_id name",
            },
          ],
        };
        if (payload.subCategoryArr && payload.subCategory === "Others") {
          query.subCategory = {
            $nin: payload.subCategoryArr,
          };
        } else {
          query.subCategory = payload.subCategory;
        }
        if (payload.scope === "Public") {
          query.scope = "Public";
          sCPlaybook = await publicPlayboooksService.find({
            query: query,
          });
        }
        if (payload.scope === "Private") {
          query.scope = "Private";
          query.organizationId = payload.organizationId;
          sCPlaybook = await practicesService.find({
            query: query,
          });
        }
        dispatch.lifeCycle.setPackList(sCPlaybook);
      }
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "fail to get");
        throw err;
      }
    },
    async getCounts(payload) {
      let filterData = payload;
      const query = {
        organizationId:payload.id
      }
      try {
        dispatch.lifeCycle.setError(null);
        const packCounts = await practicesSummaryService.get(filterData,{query});
        dispatch.lifeCycle.setPackCount(packCounts);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        throw err;
      }
    },
    async createActivity(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        payload.type = "add";
        await activitiesService.create(payload);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Error adding activity");
        throw err;
      }
    },
    async updateActivity(payload, state) {
      try {
        dispatch.lifeCycle.setError(null);
        const updateOldActivity = await activitiesService.patch(
          payload.id,
          { name: payload.name },
          {
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );
        // dispatch.createPack.setSelectedActivity(updateOldActivity);
        dispatch.lifeCycle.updateSelectedPracticeLibrary({
          id: updateOldActivity._id,
          element: "activities",
          data: updateOldActivity,
        });
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Error updating activity");
        dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(
          payload.packId
        );
        throw err;
      }
    },
    async createCommunity(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        await communitiesService.create(payload);
        // dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(payload.packId);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Error adding community");
        throw err;
      }
    },
    async updateCommunity(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        const updateOldCommunity = await communitiesService.patch(payload.id, {
          name: payload.name,
        });
        dispatch.createPack.setSelectedCommunity(updateOldCommunity);
        // dispatch.lifeCycle.updateSelectedPracticeLibrary({ id: updateOldCommunity._id, element: 'communities', data: updateOldCommunity })
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Error updating community");
        dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(
          payload.packId
        );
        throw err;
      }
    },
    setDeleteParticipantsAsync(payload) {
      dispatch.lifeCycle.setDeleteParticipants(payload);
    },
    setBreadCrumbsData(payload) {
      dispatch.lifeCycle.setBreadCrumbs(payload);
    },

    async getPackAndUpdateSelectedPracticeLibary(payload, state) {
      dispatch.lifeCycle.setError(null);
      try {
        const packData = await practicesService.get(payload, {
          query: {
            $populate: [
              {
                path: "participants.accountUserId",
                populate: "accountUserId",
                select: "_id firstName lastName profilePic email",
              },
              {
                path: "notes.accountUserId",
                populate: "accountUserId",
                select: "_id firstName lastName profilePic email ",
              },
              {
                path: "attachments.uploadedBy",
                populate: "uploadedBy",
                select: "_id firstName lastName profilePic ",
              },
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id, name",
              },
              { path: "category", populate: "category", select: "_id, name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id, name",
              },
              { path: "teamId", model: "suborganizations", select: "name" },
            ],
          },
        });
        let setData = [];
        for (let i = 0; i < packData.participants.length; i++) {
          setData.push({
            accountUserId: packData.participants[i].accountUserId._id,
            role: packData.participants[i].role,
            name: packData.participants[i].name,
            firstName: packData.participants[i].accountUserId.firstName,
            lastName: packData.participants[i].accountUserId.lastName,
            imageUrl: packData.participants[i].accountUserId.profilePic,
            email: packData.participants[i].accountUserId.email,
          });
        }
        packData.participants = setData;
        packData.cycles = [];
        dispatch.lifeCycle.setSelectedPracticeLibraryData(packData);
        return true;
      } catch (e) {
        if (e.code === 403) {
          return dispatch(push(`/app/${state.app.selectedAccount._id}/403`));
        }
        if (e.code === 404) {
          return dispatch(push(`/app/${state.app.selectedAccount._id}/404`));
        }
      }
    },
    async isPlaybookAvailable(payload, state) {
      try {
        const packData = await practicesService.get(payload);
        if (state.home.redirectFromDashboard && packData) {
          if (packData.status === 4 || packData.status === 5) {
            await dispatch(
              push(
                `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_pb/status/knowledgeBank`
              )
            );
          } else {
            await dispatch(
              push(
                `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_pb`
              )
            );
          }
          await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(
            payload
          );
          dispatch.lifeCycle.setSinglePlaybookData(packData);
        }
      } catch (e) {
        if (state.home.redirectFromDashboard) {
          dispatch.home.eventDetailsNotFound(true);
        }
      }
    },
    async setSingleActivityDetail(payload) {
      let query = {
        $populate: [
          { path: "accountId", populate: "accountId", select: "_id name logo" },
          {
            path: "organizationId",
            populate: "organizationId",
            select: "_id name",
          },
          {
            path: "packId",
            select: "_id name picture scope baseCategory category subCategory",
            populate: [
              {
                path: "createdBy",
                populate: "createdBy",
                select: "_id firstName lastName profilePic email",
              },
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          },
        ],
      };
      const activity = await activitiesService.get(payload.id, {
        query: query,
      });
      dispatch.lifeCycle.setSingleActivity(activity);
    },
    async deleteActivity(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        await activitiesService.remove(payload.id);
        // await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(payload.packId);
        //dispatch.lifeCycle.showResourecePane(null)
        dispatch.createPack.setSelectedActivity({});
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Error deleting activity");
        throw err;
      }
    },
    async deleteCommunity(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        await communitiesService.remove(payload.id);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Error deleting community");
        throw err;
      }
    },
    modalRoleChangeOpen(onOffState) {
      dispatch.lifeCycle.setRoleChangeModalOpen(onOffState);
    },
    createPracticeCard(payload) {
      dispatch.lifeCycle.setCreatePracticeCard(payload);
    },
    async publishPractice(payload, state) {
      try {
        await practicesService.patch(
          payload._id,
          {
            $set: { status: 4 },
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // Added for KLM-9016
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // Added for KLM-9016
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
        toastr.success("Message", "Playbook published Successfully");
      } catch (err) {
        toastr.error("Message", err.message);
      }
    },

    addPracticeToReview(payload, state) {
      try {
        practicesService.patch(
          payload.id,
          {
            $set: { status: 1, reviewStatus: payload.reviewers },
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
        toastr.success("Message", "Playbook added to Review");
        dispatch.lifeCycle.getCounts({ id: payload.organizationId });
        return dispatch(
          push(
            `/app/${payload.accountId}/_ws/${payload.organizationId}/_pb/status/inReview`
          )
        );
      } catch (err) {
        toastr.error("Message", "Error publishing practice");
      }
    },
    approvePractice(payload, state) {
      try {
        practicesService.patch(
          payload.id,
          {
            $set: {
              status: 2,
              reviewStatus: payload.reviewers,
              reviewHistory: payload.reviewers,
            },
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
        dispatch.lifeCycle.getCounts({ id: payload.organizationId });
      } catch (err) {
        toastr.error("Message", "Error publishing practice");
      }
    },
    rejectPractice(payload, state) {
      try {
        practicesService.patch(
          payload.id,
          {
            $set: { status: 3, reviewStatus: payload.reviewers },
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
        toastr.success("Message", "Playbook is Rejected");
        dispatch.lifeCycle.getCounts({ id: payload.organizationId });
        dispatch.lifeCycle.setSelectedPracticeLibrary({});
        return dispatch(
          push(`/app/${payload.accountId}/_ws/${payload.organizationId}/_pb`)
        );
      } catch (err) {
        toastr.error("Message", "Error rejecting playbook");
      }
    },
    preparePracticeForInDesign(payload) {
      dispatch.lifeCycle.preparePracticeToMoveInDesign(payload);
    },
    movePracticeToIndesign(payload, state) {
      try {
        practicesService.patch(
          payload.selectedPracticeLibrary._id,
          {
            $set: {
              status: 0,
              reviewStatus: [],
              reviewHistory: payload.selectedPracticeLibrary.reviewStatus,
            },
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
        dispatch.lifeCycle.getCounts({ id: payload.organizationId });
        return dispatch(
          push(`/app/${payload.accountId}/_ws/${payload.organizationId}/_pb`)
        );
      } catch (err) {
        toastr.error("Message", "Error updating playbook");
      }
    },
    async getPacksInReview(payload) {
      let filterData = payload;
      try {
        dispatch.lifeCycle.setError(null);
        const Packdata = await practicesService.find({
          query: {
            $and: [
              { organizationId: filterData.organizationId, status: 1 },
              {
                participants: {
                  $elemMatch: {
                    accountUserId: filterData.user._id,
                    role: { $ne: "reviewer" },
                  },
                },
              },
            ],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
            $sort: { createdAt: -1 },
          },
        });
        dispatch.lifeCycle.setPackList(Packdata);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "fail to get Playbooks in Review");
        throw err;
      }
    },
    async getPacksForReview(payload) {
      let filterData = payload;
      try {
        dispatch.lifeCycle.setError(null);
        const Packdata = await practicesService.find({
          query: {
            $and: [
              { organizationId: filterData.organizationId, status: 1 },
              {
                participants: {
                  $elemMatch: {
                    accountUserId: filterData.user._id,
                    role: "reviewer",
                  },
                },
              },
            ],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],

            $sort: { createdAt: -1 },
          },
        });
        dispatch.lifeCycle.setPackList(Packdata);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "fail to get Playbooks for Review");
        throw err;
      }
    },
    async getUnderReviewPacks(payload) {
      let filterData = payload;
      try {
        dispatch.lifeCycle.setError(null);
        const Packdata = await practicesService.find({
          query: {
            $and: [
              { organizationId: filterData.organizationId },
              { status: 1 },
              {
                participants: {
                  $elemMatch: { accountUserId: filterData.user._id },
                },
              },
            ],
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
            $sort: { createdAt: -1 },
          },
        });
        dispatch.lifeCycle.setPackList(Packdata);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "failed to get Playbooks Review request");
        throw err;
      }
    },
    async getPublicallyPublishedPacks() {
      try {
        dispatch.lifeCycle.setError(null);
        const Packdata = await practicesService.find({
          query: {
            status: 4,
            scope: "Public",
            $populate: [
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          },
        });
        dispatch.lifeCycle.setPackList(Packdata);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "fail to get Published Playbooks");
        throw err;
      }
    },
    displaySecondMenu(payload) {
      dispatch.lifeCycle.displaySecondMenuFlagSet(payload);
    },
    async getActivities(payload, state) {
      let query = {
        organizationId: payload.organizationId,
        practiceId: payload.practiceId,
        limit: payload.limit ? payload.limit : 10,
      };

      if (!_.isEmpty(payload.baseCategory)) {
        query.baseCategory = payload.baseCategory._id
          ? payload.baseCategory._id
          : payload.baseCategory;
      }
      if (!_.isEmpty(payload.category)) {
        query.baseCategory = payload.baseCategory._id
          ? payload.baseCategory._id
          : payload.baseCategory;
        query.category = payload.category._id
          ? payload.category._id
          : payload.category;
      }
      if (!_.isEmpty(payload.subCategory)) {
        query.baseCategory = payload.baseCategory._id
          ? payload.baseCategory._id
          : payload.baseCategory;
        query.category = payload.category._id
          ? payload.category._id
          : payload.category;
        query.subCategory = payload.subCategory._id
          ? payload.subCategory._id
          : payload.subCategory;
      } else if (
        state.lifeCycle.selectedPracticeLibrary &&
        state.lifeCycle.selectedPracticeLibrary.baseCategory &&
        state.lifeCycle.selectedPracticeLibrary.category &&
        state.lifeCycle.selectedPracticeLibrary.subCategory
      ) {
        query.baseCategory = state.lifeCycle.selectedPracticeLibrary
          .baseCategory._id
          ? state.lifeCycle.selectedPracticeLibrary.baseCategory._id
          : state.lifeCycle.selectedPracticeLibrary.baseCategory;
        query.category = state.lifeCycle.selectedPracticeLibrary.category._id
          ? state.lifeCycle.selectedPracticeLibrary.category._id
          : state.lifeCycle.selectedPracticeLibrary.category;
        query.subCategory = state.lifeCycle.selectedPracticeLibrary.subCategory
          ._id
          ? state.lifeCycle.selectedPracticeLibrary.subCategory._id
          : state.lifeCycle.selectedPracticeLibrary.subCategory;
      }
      if (payload.subCategoryArr && payload.subCategory === "Others") {
        query.subCategory = {
          $nin: payload.subCategoryArr,
        };
      }
      // else {
      //     query.subCategory = payload.subCategory
      // }
      if (payload.name) {
        payload.name = payload.name.replace("*", "\\*");
        payload.name = payload.name.replace("(", "(");
        payload.name = payload.name.replace(")", ")");
        payload.name = payload.name.replace("+", "\\+");
        payload.name = payload.name.replace("?", "\\?");
        payload.name = payload.name.replace("[", "[");
        payload.name = payload.name.replace("]", "]");

        query.name = { $regex: payload.name, $options: "i" };
      }
      if (payload.scope) {
        query.scope = payload.scope;
      }

      let activities = await publishedActivitiesService.find({
        query: query,
        $sort: {
          updatedAt: -1,
        },
      });
      dispatch.lifeCycle.storeActivities(activities[0].activity);
      dispatch.lifeCycle.setPublishActivityCountByCategory(activities[0].total);
    },
    setIsDragableFlag(payload) {
      dispatch.lifeCycle.setIsDragable(payload);
    },
    setInvitedParticipantAsync(payload) {
      dispatch.lifeCycle.setInvitedParticipantData(payload);
    },
    async getPlaybookToExport(payload) {
      let playbookToExport = await practiceExportService.get(payload);
      dispatch.lifeCycle.getPlaybookDataToExport(playbookToExport);
      return;
    },
    clearExportedPlaybook() {
      dispatch.lifeCycle.getPlaybookDataToExport({});
    },
    async importPlaybook(payload, state) {
      let importedPlaybook = await importPracticesService.create({
        data: payload,
        accountId: payload.accountId,
        organizationId: payload.organizationId,
      });
      // dispatch(push(state.app.playbookPath ? `/app/${payload.accountId}/_ws/${payload.workspaceId}/_pb/${state.app.playbookPath.split('_pb/')[1]}` :`/app/${payload.accountId}/_ws/${payload.organizationId}/_pb/status/In Design`));
      if (importedPlaybook.isError) {
        if (importedPlaybook.message === "invalidFile") {
          toastr.error("Message", "Invalid File.");
        } else {
          toastr.error("Message", "Error while importing Playbook.");
        }

        dispatch.lifeCycle.isPlaybookImportLoading(true);
      }
      toastr.success("Message", `${importedPlaybook.data.name} playbook imported successfully.`)
      await dispatch.lifeCycle.setCreatePracticeCard(true);
      await dispatch.lifeCycle.setFilterByStatus(["0"]);
      await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: state.app.selectedOrganisation.id, status: ["0"], accountUserId: state.app.user._id, role: state.app.selectedOrganisation.role })
       return dispatch(push(`/app/${payload.accountId}/_ws/${payload.organizationId}/_pb/status/In Design`));
      return;
    },

    async getInviteByPackIdAsync(payload) {
      try {
        dispatch.lifeCycle.setError(null);
        const InviteData = await invitesService.find({
          query: {
            referenceId: payload,
            referenceCollection: "practices",
            isAccepted: false,
          },
        });
        dispatch.lifeCycle.setPackInvitedData(InviteData.data);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "fail to get the Playbook");
        throw err;
      }
    },
    setPackInvitedData(payload) {
      dispatch.lifeCycle.setInvitaionInsidePlaybook(payload);
    },
    setDeleteInviteUserAsync(payload) {
      dispatch.lifeCycle.setDeleteInviteUser(payload);
    },
    resendAndDeleteInviteModal(onOffState) {
      dispatch.lifeCycle.resendAndDeleteInviteModalOpen(onOffState);
    },
    async deleteInvitaionAsync(payload) {
      try {
        await invitesService.remove(payload._id);
        dispatch.lifeCycle.resendAndDeleteInviteModal(false);
        if (payload.referenceCollection === "practices") {
          dispatch.lifeCycle.getInviteByPackIdAsync(payload.referenceId);
        } else if (payload.referenceCollection === "suborganizations") {
          dispatch.initiatives.getInviteBySubOrgAsync(payload.referenceId);
        }

        toastr.success("Message", "Invitation deleted successfully");
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Failed to delete invitation");
      }
    },
    async resendInvitation(payload) {
      const emailObject = payload;
      try {
        await mailsenderService.create(emailObject);
        dispatch.lifeCycle.resendAndDeleteInviteModal(false);
        toastr.success("Message", "Invitation sent successfully");
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "Failed to resend invite");
      }
    },
    async getCommunities(payload) {
      try {
        await communitiesService.find({
          query: {
            "raci.a": { $elemMatch: { a: payload.a } },
          },
        });
      } catch (err) {
        dispatch.lifeCycle.setError(err);
      }
    },

    async createInvitationForPlaybookAsync(payload) {
      payload.email = payload.email.toLowerCase();
      payload.StrType = "createInviteForOrgToPlaybook";
      payload.String = "ChckBeforeCreateInvite";
      try {
        await invitesService.create(payload);

        dispatch.lifeCycle.getInviteByPackIdAsync(payload.referenceId);
        toastr.success("Message", "User invited successfully");
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        if (
          err.response &&
          err.response.statusCode &&
          (err.response.statusCode === 409 || err.response.statusCode === 500)
        ) {
          toastr.error("Message", "User with same email id already exists");
        } else {
          toastr.error("Message", "Error while inviting user.");
        }
        throw err;
      }
    },
    async deletePlaybook(payload, state) {
      try {
        await practicesService.remove(payload.packid);
        toastr.success("Message", "Playbook deleted successfully");
        dispatch.lifeCycle.showResourecePane(false);
        let getPlaybookPayload = {
          organizationId: payload.organizationId,
          user: {
            _id: payload.userid,
          },
          role: state.app.selectedOrganisation.role,
        };
        await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: state.app.selectedOrganisation.id, status: state.lifeCycle.filterByStatus, accountUserId: state.app.user._id, role: state.app.selectedOrganisation.role })
        dispatch.lifeCycle.setSelectedPracticeLibrary({});
        //return dispatch(push(`/app/${payload.accountId}/_ws/${payload.organizationId}/_pb`));
      } catch (err) {
        toastr.error("Message", "Error while deleting playbook");
      }
    },

    async setCommunityTagColor(payload) {
      try {
        await communitiesService.patch(payload._id, payload);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
      }
    },
    setRouteParams(payload) {
      dispatch.lifeCycle.addRoutParams(payload);
    },
    setInitState(payload) {
      dispatch.lifeCycle.setInitStatus(payload);
    },
    updatePacksList(payload, state) {
      for (let pack of state.lifeCycle.packArray) {
        if (pack._id.toString() === payload._id.toString()) {
          for (let key of Object.keys(payload.data)) {
            pack[key] = payload.data[key];
          }

          break;
        }
      }
      dispatch.lifeCycle.setPackList(state.lifeCycle.packArray);
    },
    updateSelectedPracticeLibrary(payload, state) {
      let matched = false;
      for (
        let i = 0;
        i < state.lifeCycle.selectedPracticeLibrary[payload.element].length;
        i++
      ) {
        if (
          state.lifeCycle.selectedPracticeLibrary[payload.element][
            i
          ]._id.toString() === payload.id
        ) {
          state.lifeCycle.selectedPracticeLibrary[payload.element][i].name =
            payload.data.name;
          matched = true;
          break;
        }
        if (state.lifeCycle.selectedPracticeLibrary[payload.element][i]) {
          for (
            let j = 0;
            j <
            state.lifeCycle.selectedPracticeLibrary[payload.element][i][
              payload.element
            ].length;
            j++
          ) {
            if (
              state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                payload.element
              ][j]._id.toString() === payload.id.toString()
            ) {
              state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                payload.element
              ][j].name = payload.data.name;
              matched = true;
              break;
            }
            if (
              state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                payload.element
              ][j] &&
              state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                payload.element
              ][j][payload.element]
            ) {
              for (
                let k = 0;
                k <
                state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                  payload.element
                ][j][payload.element].length;
                k++
              ) {
                if (
                  state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                    payload.element
                  ][j][payload.element][k]._id.toString() ===
                  payload.id.toString()
                ) {
                  state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                    payload.element
                  ][j][payload.element][k].name = payload.data.name;
                  state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                    payload.element
                  ][j][payload.element][k].duration = payload.data.duration;
                  state.lifeCycle.selectedPracticeLibrary[payload.element][i][
                    payload.element
                  ][j][payload.element][k].isMilestone =
                    payload.data.isMilestone;
                  matched = true;
                  break;
                }
              }
            }

            if (matched) {
              break;
            }
          }
        }

        if (matched) {
          break;
        }
      }
      if (payload.element === "activities") {
        if (state.lifeCycle.selectedPracticeLibrary.communities) {
          for (
            let i = 0;
            i < state.lifeCycle.selectedPracticeLibrary.communities.length;
            i++
          ) {
            if (
              state.lifeCycle.selectedPracticeLibrary.communities[i].communities
            ) {
              for (
                let j = 0;
                j <
                state.lifeCycle.selectedPracticeLibrary.communities[i]
                  .communities.length;
                j++
              ) {
                if (
                  state.lifeCycle.selectedPracticeLibrary.communities[i]
                    .communities[j].activities
                ) {
                  for (
                    let k = 0;
                    k <
                    state.lifeCycle.selectedPracticeLibrary.communities[i]
                      .communities[j].activities.length;
                    k++
                  ) {
                    if (
                      state.lifeCycle.selectedPracticeLibrary.communities[
                        i
                      ].communities[j].activities[k]._id.toString() ===
                      payload.id.toString()
                    ) {
                      state.lifeCycle.selectedPracticeLibrary.communities[
                        i
                      ].communities[j].activities[k].name = payload.data.name;
                      matched = true;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }
      dispatch.lifeCycle.setSelectedPracticeLibraryData(
        state.lifeCycle.selectedPracticeLibrary
      );
    },
    insertActivityInParent(payload, state) {
      const getColor = (id, communities) => {
        if (!id) return "#fff";
        for (let community of communities) {
          if (community._id.toString() === id.toString()) {
            return community.tagColor;
          }
          for (let subcommunity of community.communities) {
            if (subcommunity._id.toString() === id.toString()) {
              return subcommunity.tagColor;
            }
          }
        }
      };
      let practice = Object.assign({}, state.lifeCycle.selectedPracticeLibrary);
      if (
        !_.isEmpty(practice) &&
        payload.packId &&
        practice._id &&
        practice._id.toString() === payload.packId.toString()
      ) {
        state.lifeCycle.selectedPracticeLibrary.sequenceViewMap.set(
          payload._id,
          payload
        );
        if (!payload.parentActivity) {
          practice.activities.push(payload);
        } else if (practice.activities) {
          for (let i = 0; i < practice.activities.length; i++) {
            if (
              practice.activities[i] &&
              practice.activities[i]._id &&
              practice.activities[i]._id.toString() ===
                payload.parentActivity.toString()
            ) {
              if (payload.isParentNode) {
                payload.cards = [];
                if (state.lifeCycle.displaySecondMenu === "Activities") {
                  if (practice.activities[i].activities.length !== 0) {
                    let leafActivities = practice.activities[
                      i
                    ].activities.filter((activity) => {
                      return activity.isLeafNode;
                    });
                    let parentActivities = practice.activities[
                      i
                    ].activities.filter((activity) => {
                      return activity.isParentNode;
                    });

                    payload.title = payload.name;
                    payload.communityTagColor =
                      payload.raci && payload.raci.a
                        ? getColor(payload.raci.a, practice.communities)
                        : "#fff";
                    payload.label = 0;
                    if (leafActivities.length === 0) {
                      let lane = {
                        _id: practice.activities[i]._id,
                        title: "Others",
                        cards: [],
                        label: 0,
                        communityTagColor:
                          practice.activities[i].raci &&
                          practice.activities[i].raci.a
                            ? getColor(
                                practice.activities[i].raci.a,
                                practice.communities
                              )
                            : "#fff",
                        isDummy: true,
                      };
                      if (state.lifeCycle.eventBus) {
                        state.lifeCycle.eventBus[
                          practice.activities[i]._id
                        ].publish({
                          type: "UPDATE_LANES",
                          lanes: [
                            ...practice.activities[i].activities,
                            payload,
                            lane,
                          ],
                        });
                      }
                    } else {
                      let lane = {
                        _id: practice.activities[i]._id,
                        title: "Others",
                        cards: leafActivities,
                        label: 0,
                        communityTagColor:
                          practice.activities[i].raci &&
                          practice.activities[i].raci.a
                            ? getColor(
                                practice.activities[i].raci.a,
                                practice.communities
                              )
                            : "#fff",
                        isDummy: true,
                      };
                      if (state.lifeCycle.eventBus) {
                        state.lifeCycle.eventBus[
                          practice.activities[i]._id
                        ].publish({
                          type: "UPDATE_LANES",
                          lanes: [...parentActivities, payload, lane],
                        });
                      }
                    }
                  } else {
                    payload.title = payload.name;
                    payload.communityTagColor =
                      payload.raci && payload.raci.a
                        ? getColor(payload.raci.a, practice.communities)
                        : "#fff";
                    payload.label = 0;
                    if (state.lifeCycle.eventBus) {
                      state.lifeCycle.eventBus[
                        practice.activities[i]._id
                      ].publish({ type: "UPDATE_LANES", lanes: [payload] });
                    }
                  }
                }
              } else {
                payload.title = payload.name;
                payload.boardId = practice.activities[i]._id;
                payload.laneId = practice.activities[i]._id;
                if (payload.raci && payload.raci.a) {
                  payload.communityTagColor = getColor(
                    payload.raci.a,
                    practice.communities
                  );
                }
                if (practice.activities[i].activities.length !== 0) {
                  let leafNode = false;
                  practice.activities[i].activities.forEach((activity) => {
                    if (activity.isLeafNode) {
                      leafNode = true;
                    }
                  });
                  if (!leafNode) {
                    let lane = {
                      _id: practice.activities[i]._id,
                      title: "Others",
                      cards: [],
                      label: 0,
                      communityTagColor:
                        practice.activities[i].raci &&
                        practice.activities[i].raci.a
                          ? getColor(
                              practice.activities[i].raci.a,
                              practice.communities
                            )
                          : "#fff",
                      isDummy: true,
                    };
                    if (state.lifeCycle.eventBus) {
                      state.lifeCycle.eventBus[
                        practice.activities[i]._id
                      ].publish({
                        type: "UPDATE_LANES",
                        lanes: [...practice.activities[i].activities, lane],
                      });
                    }
                  }
                } else {
                  let lane = {
                    _id: practice.activities[i]._id,
                    title: "Others",
                    cards: [],
                    label: 0,
                    communityTagColor:
                      practice.activities[i].raci &&
                      practice.activities[i].raci.a
                        ? getColor(
                            practice.activities[i].raci.a,
                            practice.communities
                          )
                        : "#fff",
                    isDummy: true,
                  };
                  if (state.lifeCycle.eventBus) {
                    if (state.lifeCycle.eventBus[practice.activities[i]._id]) {
                      state.lifeCycle.eventBus[
                        practice.activities[i]._id
                      ].publish({ type: "UPDATE_LANES", lanes: [lane] });
                    }
                  }
                }
                if (state.lifeCycle.eventBus) {
                  if (state.lifeCycle.eventBus[practice.activities[i]._id]) {
                    state.lifeCycle.eventBus[
                      practice.activities[i]._id
                    ].publish({
                      type: "ADD_CARD",
                      laneId: practice.activities[i]._id,
                      card: payload,
                    });
                  }
                }
              }
              practice.activities[i].activities.push(payload);

              break;
            }
            if (practice.activities[i].activities) {
              for (
                let j = 0;
                j < practice.activities[i].activities.length;
                j++
              ) {
                if (
                  practice.activities[i].activities[j]._id.toString() ===
                  payload.parentActivity.toString()
                ) {
                  payload.title = payload.name;
                  payload.boardId = practice.activities[i]._id;
                  payload.laneId = practice.activities[i].activities[j]._id;
                  if (payload.raci && payload.raci.a) {
                    payload.communityTagColor = getColor(
                      payload.raci.a,
                      practice.communities
                    );
                  }
                  if (
                    state.lifeCycle.eventBus &&
                    state.lifeCycle.eventBus[practice.activities[i]._id]
                  ) {
                    state.lifeCycle.eventBus[
                      practice.activities[i]._id
                    ].publish({
                      type: "ADD_CARD",
                      laneId: practice.activities[i].activities[j]._id,
                      card: payload,
                    });
                  }

                  state.lifeCycle.selectedPracticeLibrary.activities[
                    i
                  ].activities[j].activities.push(payload);
                  break;
                }
              }
            }
          }
          for (let i = 0; i < practice.communities.length; i++) {
            for (
              let j = 0;
              j < practice.communities[i].communities.length;
              j++
            ) {
              if (
                payload.raci &&
                payload.raci.r &&
                payload.raci.r.includes(
                  practice.communities[i].communities[j]._id
                )
              ) {
                practice.communities[i].communities[j].activities.push(payload);
              }
            }
          }
        }
      }
      // dispatch.lifeCycle.setSelectedPracticeLibraryData(Object.assign({}, practice));
    },
    insertCommunityInParent(payload, state) {
      let practice = Object.assign({}, state.lifeCycle.selectedPracticeLibrary);
      if (
        !_.isEmpty(practice) &&
        payload.packId &&
        practice._id &&
        practice._id.toString() === payload.packId.toString()
      ) {
        if (!payload.parentCommunity) {
          practice.communities.push(payload);
        } else if (practice.communities) {
          for (let i = 0; i < practice.communities.length; i++) {
            if (
              practice.communities[i] &&
              practice.communities[i]._id &&
              practice.communities[i]._id.toString() ===
                payload.parentCommunity.toString()
            ) {
              if (!practice.communities[i].communities) {
                practice.communities[i].communities = [];
              }

              practice.communities[i].communities.push(payload);
            }
          }
        }
      }
      dispatch.lifeCycle.setSelectedPracticeLibraryData(
        Object.assign({}, practice)
      );
    },
    setIdToCenterPosition(payload) {
      dispatch.lifeCycle.setDBUniqueId(payload);
    },
    splitAt(payload) {
      dispatch.lifeCycle.setSplitAtSize(payload);
    },
    addEdge(payload, state) {
      state.lifeCycle.graph.addEdge(payload.fromVertex, payload.toVertex);
    },
    removeEdge(payload, state) {
      state.lifeCycle.graph.removeEdge(payload.fromVertex, payload.toVertex);
    },

    async duplicateActivity(activityId) {
      try {
        await duplicateActivityService.create({ activityId: activityId });
      } catch (err) {
        dispatch.lifeCycle.setError(err);
      }
    },
    async createduplicateActivity(data) {
      try {
        await duplicateActivityService.create({ Data: data });
      } catch (err) {
        dispatch.lifeCycle.setError(err);
      }
    },
    updateSelectedDataById(payload, state) {
      dispatch.lifeCycle.updatePacksList({ _id: payload._id, data: payload });
      let playbook = Object.assign({}, state.lifeCycle.selectedPracticeLibrary);
      if (
        playbook &&
        playbook._id &&
        playbook._id.toString() === payload._id.toString()
      ) {
        for (let key of Object.keys(payload)) {
          if (key !== "_id") {
            playbook[key] = payload[key];
          }
        }
        if (!payload.template) {
          delete playbook.template;
        }
        dispatch.lifeCycle.setSelectedPracticeLibrary(playbook);
      }
    },
    setEventBusHandle(payload) {
      dispatch.lifeCycle.setEventBus(payload);
    },
    setCommunityEventBusHandle(payload) {
      dispatch.lifeCycle.setCommunityEventBus(payload);
    },
    activePage(payload) {
      dispatch.lifeCycle.setActivePage(payload);
    },
    throwOtherUsersOnNotFound(payload, state) {
      if (
        state.lifeCycle.packArray &&
        state.lifeCycle.packArray.filter((pack) => {
          return pack._id.toString() === payload._id.toString();
        }).length > 0
      ) {
        dispatch.lifeCycle.setPackList(
          state.lifeCycle.packArray.filter((pack) => {
            return pack._id.toString() !== payload._id.toString();
          })
        );
      }
      if (
        state.lifeCycle.selectedPracticeLibrary &&
        state.lifeCycle.selectedPracticeLibrary._id &&
        state.lifeCycle.selectedPracticeLibrary._id.toString() ===
          payload._id.toString()
      ) {
        dispatch.lifeCycle.setSelectedPracticeLibraryData({});

        if (
          payload.deletedBy.toLowerCase() !==
          state.app.user.firstName.toLowerCase() +
            " " +
            state.app.user.lastName.toLowerCase()
        ) {
          dispatch.app.setCollapsedResourcePaneIndexTemp(null);
          dispatch.lifeCycle.showResourecePane(null);
          dispatch.lifeCycle.setArrangementPaneFlag(false);
          return dispatch(
            push(
              `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_pb`
            )
          );
        }
      }
    },
    async removeAllDependenciesFromPlaybook(payload, state) {
      await playbookDependenciesService.remove(payload);
      await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(
        state.lifeCycle.selectedPracticeLibrary._id
      );
      if (state.createPack.selectedPracticeFlowActivity._id) {
        await dispatch.createPack.getSelectedActivityAsync(
          state.createPack.selectedPracticeFlowActivity._id
        );
      }
    },
    async activityDupliacted(data, state) {
      if (state.app.currentContext === "designer") {
        if (
          state.lifeCycle.selectedPracticeLibrary &&
          state.lifeCycle.selectedPracticeLibrary._id.toString() ===
            data.packId.toString()
        ) {
          await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(
            data.packId
          );
        }
      }
    },

    async editParticipantsAsync(payload, state) {
      const editPack = payload.selectedPack;
      try {
        await practicesService.patch(
          editPack._id,
          {
            $set: { participants: editPack.participants },
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
        await dispatch.lifeCycle.updatePacksList({
          _id: editPack._id,
          data: { name: editPack.name },
        });
        await dispatch.lifeCycle.getInviteByPackIdAsync(editPack._id);
        await dispatch.lifeCycle.setPlaybookError(null);
      } catch (err) {
        let errMessage = null;
        if (err.message.indexOf("already exists") !== -1) {
          errMessage = "Playbook with same name already exists.";
        } else {
          errMessage = "Error while updating playbook.";
          toastr.error("Message", errMessage);
        }
        dispatch.lifeCycle.setPlaybookError(errMessage);
        throw err;
      }
    },

    async updatePlaybook(payload, state) {
      // Below changes for KLM-9002
      try {
        const updatedPlaybook = await practicesService.patch(
          payload._id,
          {
            $set: payload.data,
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "participants.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email",
                },
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
        await dispatch.lifeCycle.updatePacksList({
          _id: payload._id,
          data: { name: payload.name },
        });
        await dispatch.lifeCycle.getInviteByPackIdAsync(payload._id);
        await dispatch.lifeCycle.setPlaybookError(null);
        await dispatch.lifeCycle.getCategoryTreeAsync({
          accountId: payload.accountId,
        });
      } catch (err) {
        let errMessage = null;
        if (err.message.indexOf("already exists") !== -1) {
          errMessage = "Playbook with same name already exists.";
        } else {
          errMessage = "Error while updating playbook.";
          toastr.error("Message", errMessage);
        }
        dispatch.lifeCycle.setPlaybookError(errMessage);
        throw err;
      }
    },
    async updateAttachnmentInActivity(payload, state) {
      try {
        await activitiesService.patch(
          payload._id,
          { $set: payload.data },
          {
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );
      } catch (err) {
        throw err;
      }
    },

    async updatePlaybookBySpecificFields(payload, state) {
      try {
        let updateRecord = {};
        for (let key of Object.keys(payload)) {
          if (key !== "_id") {
            updateRecord[key] = payload[key];
          }
        }
        if (payload._id) {
          await practicesService.patch(
            payload._id,
            {
              $set: updateRecord,
              accountId: state.lifeCycle.selectedPracticeLibrary.accountId, // KLM-9018
              organizationId:
                state.lifeCycle.selectedPracticeLibrary.organizationId, // KLM-9018
            },
            {
              query: {
                $populate: [
                  {
                    path: "participants.accountUserId",
                    populate: "accountUserId",
                    select: "_id firstName lastName profilePic email",
                  },
                  {
                    path: "notes.accountUserId",
                    populate: "accountUserId",
                    select: "_id firstName lastName profilePic email ",
                  },
                  {
                    path: "attachments.uploadedBy",
                    populate: "uploadedBy",
                    select: "_id firstName lastName profilePic ",
                  },
                  {
                    path: "baseCategory",
                    populate: "baseCategory",
                    select: "_id name",
                  },
                  {
                    path: "category",
                    populate: "category",
                    select: "_id name",
                  },
                  {
                    path: "subCategory",
                    populate: "subCategory",
                    select: "_id name",
                  },
                ],
              },
            }
          );
          dispatch.lifeCycle.updateSelectedDataById(payload);
          dispatch.lifeCycle.setPlaybookError(null);
        }
      } catch (err) {
        let errMessage = null;
        if (err.message.indexOf("already exists") !== -1) {
          errMessage = "Playbook with same name already exists.";
        } else {
          errMessage = "Error while updating playbook.";
          toastr.error("Message", errMessage);
        }

        dispatch.lifeCycle.setPlaybookError(errMessage);
        throw err;
      }
    },
    setCurrntNotesAsync(payload) {
      dispatch.lifeCycle.setCurrntNotesData(payload);
    },
    async updatePlaybookActivities(payload, state) {
      // Below changes for KLM-9002
      try {
        await activitiesService.patch(
          payload._id,
          payload,
          {
            accountId: state.lifeCycle.selectedPracticeLibrary.accountId,
            organizationId:
              state.lifeCycle.selectedPracticeLibrary.organizationId,
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );
      } catch (e) {
        dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(
          payload.packId
        );
        throw e;
      }
    },
    async getAllPlaybooksByUserIdAndTeamId(payload) {
      let query = {
        organizationId: payload.organizationId,
        accountId: payload.accountId,
        createdBy: payload.userId,
      };
      const playbooks = await practicesService.find({
        query: query,
      });
      dispatch.lifeCycle.setAllPlaybooksByUserIdAndTeamId(playbooks);
    },
    setAllPlaybooksByUserIdAndTeamId(payload) {
      dispatch.lifeCycle.setPlaybooksByUserIdAndTeamId(payload);
    },
    setTreeCurrentPath(payload) {
      dispatch.lifeCycle.treeCurrentPath(payload);
    },
    async copyPlaybook(payload,state) {
      try {
        let copiedPlaybook = await playbookCopyService.create(payload);
        toastr.success(
          "Message",
          `Playbook ${payload.oldPlaybookName} copied successfully as ${copiedPlaybook.name}`
        );
        await dispatch.lifeCycle.setCreatePracticeCard(true);
        await dispatch.lifeCycle.setFilterByStatus(["0"]);
        await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: state.app.selectedOrganisation.id, status: ["0"], accountUserId: state.app.user._id, role: state.app.selectedOrganisation.role })
        return dispatch(push(`/app/${payload.accountId}/_ws/${payload.organizationId}/_pb/status/In Design`));
      } catch (e) {
        toastr.error("Message", "Failed to copy playbook");
      }
    },
    async upgradeVersion(payload) {
      try {
        const data = await playbookVersionService.create(payload);
        if (Object.keys(data).length > 0) {
          toastr.success("Message", `New playbook version is created`);
        } else {
          toastr.error("Message", "Failed to update playbook version");
        }
      } catch (e) {
        toastr.error("Message", "Failed to update playbook version");
      }
    },
    async getPlaybookAsExcel(payload, state) {
      let playbookToExport = await practiceExcelExportService.get(payload);
      var blob = new Blob([playbookToExport], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(window.URL.createObjectURL(blob));
      } else {
        //for firfox/chrome
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = state.lifeCycle.selectedPracticeLibrary.name + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      return;
    },
    async getPlaybookAsWord(payload, state) {
      let playbookToExport = await practiceWordExportService.get(payload);
      var blob = new Blob([playbookToExport], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(window.URL.createObjectURL(blob));
      } else {
        //for firfox/chrome
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = state.lifeCycle.selectedPracticeLibrary.name + ".docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      return;
    },
    updatePlaybookTimeStamp(payload, state) {
      if (
        state.lifeCycle.selectedPracticeLibrary &&
        state.lifeCycle.selectedPracticeLibrary._id &&
        state.lifeCycle.selectedPracticeLibrary._id.toString() ===
          payload._id.toString()
      ) {
        dispatch.lifeCycle.setTimeStamp(payload.updatedAt);
      }
    },
    async getActivitySummary(payload, state) {
      let query = {
        id: payload.id,
      };
      let result = await PracticeActivitySummaryService.find({ query: query });
      dispatch.lifeCycle.setActivitySummary(result);
    },
    async getPlaybookTemplate(playbookId, state) {
      let exportTemplate = await practiceTemplateDownloadService.get(
        playbookId
      );

      var blob = new Blob([exportTemplate], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(window.URL.createObjectURL(blob));
      } else {
        //for firfox/chrome
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download =
          playbookId === "none" ||
          !state.lifeCycle.selectedPracticeLibrary.template
            ? "Default_Template.docx"
            : state.lifeCycle.selectedPracticeLibrary.template.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      return;
    },
    async uploadPlaybookTemplate(payload) {
      try {
        await practiceTemplateDownloadService.create(payload);
        toastr.success("Message", "Template uploaded successfully");
      } catch (e) {
        toastr.error("Message", "Invalid File.");
      }
    },
    async resetTemplate(payload) {
      try {
        await practiceTemplateDownloadService.remove(payload);
      } catch (e) {
        toastr.error("Message", "Issue while deleting template");
      }
    },
    async decodePlaybook(payload, state) {
      let importedPlaybook = await decodePracticesService.create({
        data: payload,
        accountId: payload.accountId,
        organizationId: payload.organizationId,
      });
      if (importedPlaybook.isError) {
        if (importedPlaybook.message === "invalidFile") {
          toastr.error("Message", "Invalid File.");
        } else {
          toastr.error("Message", "Error while importing Playbook.");
        }

        dispatch.lifeCycle.isPlaybookImportLoading(true);
      } else {
        dispatch.lifeCycle.setDecodedPlaybook(importedPlaybook);
        dispatch.categories.getAllCategories();
      }
    },
    async newPlaybookTOPackList(payload, state) {
      let packData = await practicesService.get(payload._id, {
        query: {
          $populate: [
            {
              path: "participants.accountUserId",
              populate: "accountUserId",
              select: "_id firstName lastName profilePic email",
            },
            {
              path: "notes.accountUserId",
              populate: "accountUserId",
              select: "_id firstName lastName profilePic email ",
            },
            {
              path: "attachments.uploadedBy",
              populate: "uploadedBy",
              select: "_id firstName lastName profilePic ",
            },
            {
              path: "baseCategory",
              populate: "baseCategory",
              select: "_id, name",
            },
            { path: "category", populate: "category", select: "_id, name" },
            {
              path: "subCategory",
              populate: "subCategory",
              select: "_id, name",
            },
          ],
        },
      });
      let newParticipants = [];
      for (let participant of packData.participants) {
        let newParticipant = {};
        newParticipant.accountUserId = participant.accountUserId._id;
        newParticipant.email = participant.accountUserId.email;
        newParticipant.firstName = participant.accountUserId.firstName;
        newParticipant.imageUrl = participant.accountUserId.profilePic;
        newParticipant.lastName = participant.accountUserId.lastName;
        newParticipant.name = participant.name;
        newParticipant.role = participant.role;
        newParticipants.push(newParticipant);
      }
      delete packData.participants;
      packData.participants = newParticipants;
      dispatch.lifeCycle.addNewPlaybookToPackList(Object.assign({}, packData));

      delete packData.activities;
      delete packData.communities;
      // delete packData.participants;
      //delete data.notes;

      dispatch.lifeCycle.updateSelectedDataById(packData);
    },
    async addintegrationInActivities(payload, state) {
      try {
        let result = await activitiesService.patch(payload._id, payload);
        await dispatch.createPack.getSelectedActivityAsync(payload._id);
      } catch (e) {
        throw e;
      }
    },
    async removeIntegrationInActivities(payload, state) {
      try {
        let result = await activitiesService.patch(payload._id, payload);
        //    let result = await activitiesService.patch(payload._id, {  $unset: { integration: {} }, });
        //    let result = await activitiesService.patch(payload._id, {$unset: {integration:1}});
        await dispatch.createPack.getSelectedActivityAsync(payload._id);
      } catch (e) {
        throw e;
      }
    },
    async getPlaybookById(payload) {
      const playbooks = await practicesService.get(payload);
      dispatch.lifeCycle.setSinglePlaybookData(playbooks);
    },
    async getAllPlayBooksFromBaseId(payload) {
      let query = {
        baseId: payload,
      };
      const playbooks = await playbookVersionService.find({
        query: query,
      });
      dispatch.lifeCycle.allRetrievedPlaybooksBasedOnBaseId(playbooks);
    },
    async getPacksByStatusArray(payload,state) {
      let filterData = payload;
      let status = filterData.status;
      filterData.status = filterData.status.filter((status)=>status !== "10")
      const query = {
        $and: [
          { organizationId: filterData.organizationId },
          { status: { $in: filterData.status } },
        ],
        $populate: [
          {
            path: "baseCategory",
            populate: "baseCategory",
            select: "_id name",
          },
          { path: "category", populate: "category", select: "_id name" },
          { path: "subCategory", populate: "subCategory", select: "_id name" },
        ],
        $sort: { createdAt: -1 },
      };
      if(filterData.baseCategory){
        query.$and.push({baseCategory:filterData.baseCategory})
      }
      if(filterData.category){
        query.$and.push({category:filterData.category})
      }
      if(filterData.subCategory){
        query.$and.push({subCategory:filterData.subCategory})
      }
      if (filterData.$sort) {
        query.$sort = filterData.$sort;
      } else {
        query.$sort = { createdAt: -1 };
      }
      if (filterData.status.includes("0")) {
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $ne: "reviewer" },
            },
          },
        });
      }
      if (filterData.status.includes("-1")) {
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $ne: "reviewer" },
            },
          },
        });
      }
      if (filterData.status.some(status => ["4"].includes(status)) && !(filterData.baseCategory || filterData.category || filterData.subCategory || state.app.routeParams.status === "knowledgeBank" || payload.isKnowledgeBank)) {
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $eq: "author" },
            },
          },
        });
      }
      if (filterData.status.some(status => ["1", "2", "3"].includes(status))) {
        query.$and.push({
          participants: {
            $elemMatch: { accountUserId: filterData.accountUserId },
          },
        });
        query.$and.forEach(condition => {
          if (condition.participants && condition.participants.$elemMatch && condition.participants.$elemMatch.role) {
              delete condition.participants.$elemMatch.role;
          }
      });
      }
      if(filterData.role === "Manager" || filterData.role === "Member"){
        query.$and.forEach(condition => {
          if (condition.participants) {
              delete condition.participants
          }
          if(condition.status){
            delete condition.status;
          }
        });
        query.$or=filterData.status
            .filter((status) => ["0","1","2","4","-1","5"].includes(status))
            .map((status) => {
              switch (status) {
                case "0":
                  return {
                    $and: [
                      { status: "0" },
                      {
                        participants: {
                          $elemMatch: {
                            accountUserId: filterData.accountUserId,
                            role: ["author", "contributor"],
                          },
                        },
                      },
                    ],
                  };
        
                case "1":
                     if (state.app.routeParams.status === "forReview") {
                    return {
                      $and: [
                        { status: "1" },
                        {
                          participants: {
                            $elemMatch: {
                              accountUserId: filterData.accountUserId,
                              role: ["reviewer"],
                            },
                          },
                        },
                      ],
                    };
                  } else if (state.app.routeParams.status === "inReview") {
                    return {
                      $and: [
                        { status: "1" },
                        {
                          participants: {
                            $elemMatch: {
                              accountUserId: filterData.accountUserId,
                              role: { $eq: "author" },
                            },
                          },
                        },
                      ],
                    };
                  }
                  return {
                    $and: [
                      { status: "1" },
                      {
                        participants: {
                          $elemMatch: { 
                            accountUserId: filterData.accountUserId,
                            role: { $in: ["author", "reviewer"] } 
                          },
                        },
                      },
                    ],
                  };
                case "2":
                  return {
                    $and: [
                      { status: { $in: ["2"] } },
                      {
                        participants: {
                          $elemMatch: { accountUserId: filterData.accountUserId },
                        },
                      },
                    ],
                  };
        
                case "4":
                  if (payload.baseCategory || payload.category || payload.subCategory || state.app.routeParams.status === "knowledgeBank" || payload.isKnowledgeBank) {
                    return {
                      $and: [
                        { status: "4" }
                      ],
                    };
                  } else {
                    return {
                      $and: [
                        { status: "4" },
                        {
                          participants: {
                            $elemMatch: {
                              accountUserId: filterData.accountUserId,
                              role: "author",
                            },
                          },
                        },
                      ],
                    };
                  }
                
                  case "-1":
                    return {
                      $and: [
                        { status: "-1" },
                        {
                          participants: {
                            $elemMatch: {
                              accountUserId: filterData.accountUserId,
                              role: "author",
                            },
                          },
                        },
                      ],
                  };
                  case "5":
                    return {
                      $and: [
                        { status: "5" },
                        {
                          participants: {
                            $elemMatch: {
                              accountUserId: filterData.accountUserId,
                              role: "author",
                            },
                          },
                        },
                      ],
                  };

                default:
                  return null;
              }
            })
            .filter((block) => block !== null)
      }
      if (filterData.status.some(status => ["5"].includes(status)) && !filterData.scope && !(filterData.baseCategory || filterData.category || filterData.subCategory || state.app.routeParams.status === "knowledgeBank" || payload.isKnowledgeBank)) {
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $eq: "author" },
            },
          },
        });
      }
       if (filterData.status.some(status => ["2"].includes(status)) && !(filterData.baseCategory || filterData.category || filterData.subCategory || state.app.routeParams.status === "knowledgeBank" || payload.isKnowledgeBank)) {
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $eq: "author" },
            },
          },
        });
      }

       if(filterData.scope && filterData.role === "workspaceOwner" ){
        query.$and.forEach(condition => {
          if (condition.participants) {
              delete condition.participants;
          }
      });
      }

       if(!status.includes("10") && status.includes("1") && state.app.routeParams.status === "forReview"){
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $eq: "reviewer" },
            },
          },
        });
        
        
      } else if(!status.includes("10") && status.includes("1") && state.app.routeParams.status === "inReview"){
        query.$and.push({
          participants: {
            $elemMatch: {
              accountUserId: filterData.accountUserId,
              role: { $eq: "author" },
            },
          },
        });
      }
        
      
      try {
        dispatch.lifeCycle.setError(null);
        let Packdata=[]
        console.log("query",query)
        if(filterData.scope && filterData.scope === "Public"){
          query.scope = "Public"
          query.$and.forEach(condition => {
            if (condition.organizationId) {
                delete condition.organizationId;
            }
        });
          Packdata = await publicPlayboooksService.find({
            query: query,
          });  
        }
        else{
          if(filterData.scope && filterData.scope === "Private"){
            query.scope = "Private"
          }
        Packdata = await practicesService.find({
          query: query,
        });
      }
        // dispatch.lifeCycle.setSelectedPracticeLibraryData({});
        dispatch.lifeCycle.setPackList(Packdata);
      } catch (err) {
        dispatch.lifeCycle.setError(err);
        toastr.error("Message", "failed to get playbooks");
        throw err;
      }
    },
    async getPlaybookName(payload,state){
      const playbookName = await dataProcessorPlaybookNameService.find({query:{topic:payload.topic}});
      dispatch.lifeCycle.setGeneratedPlaybookName(playbookName);
    },
    async getPlaybookStructure(payload,state){
      dispatch.lifeCycle.setPlaybook(null);
      dispatch.lifeCycle.setPlaybookGenerationState(null);
      const accountId = state.app.selectedAccount._id;
      const workspaceId = state.app.selectedOrganisation.id;
      dispatch.lifeCycle.setPlaybookGenerationIndex(0)
      dispatch.lifeCycle.setPlaybookGenerationState("Playbook Image")
      const resImageArray = await dataProcessorImageService.find({query:{
        topic:payload.name
      }});
      const pictureIndex = Math.floor(Math.random() * resImageArray.length);
      const blob = new Blob([resImageArray[pictureIndex]], { type: 'image/jpeg' });
      let formData = new FormData();
        formData.append('file', blob);
        formData.append('upload_preset', state.app.envData.preset)
        await axios({
            url: state.app.envData.cloudenaryUrl,
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: formData
        }).then((res) => {
          payload.picture =res.data.secure_url
        })
        // let randomImageNumber = Math.floor(Math.random() * 10) + 1
        //   payload.picture = "https://res.cloudinary.com/" + state.app.envData.cloudName + "/image/upload/Cards/playbook/" + randomImageNumber + ".png";
      try{
        let playbookDerivedName = `${payload.topic}`;
        let validName = false;
        let counter = 1;
        while(!validName){
          let searchQuery = {};
          searchQuery.slug = { $regex: playbookDerivedName.toLowerCase().trim().replace(/[\(\)\{\}]/g, '\\$&'), $options: "i" };
          searchQuery.organizationId = workspaceId;
          let searchedPractice = await practicesService.find({
            query: searchQuery,
          });
          if (!searchedPractice || searchedPractice.length === 0) {
            validName = true
          } else {
            validName = false
            playbookDerivedName = `${payload.topic} (${counter})`
            counter++;
          }
        }
        const pbPayload = {
          organizationId: workspaceId,
          accountId: accountId,
          name: payload.name,
          description: playbookDerivedName,
          slug: payload.name.toLowerCase().trim(),
          scope: "Private",
          baseCategory: payload.baseCategory,
          category: payload.category,
          subCategory: payload.subCategory,
          status: -1,
          playbookGenerationStatus: 0,
          genParams:payload.attributes,
          version: "1.0.0",
          totalIntances: 0,
          active: true,
          lastUpdatedBy: state.app.user._id.toString(),
          createdBy: state.app.user._id.toString(),
          accountUserId: state.app.user._id.toString(),
          participants: [
            {
              accountUserId: state.app.user._id.toString(),
              role: "author",
            },
          ],
          picture: payload.picture,
          notes: [
            {
              _id: generateObjectId(),
              content: "Auto-generated Playbook",
              accountUserId: state.app.user._id.toString(),
              notedate: new Date(),
            },
          ],
          metaData: {},
        };
         const playbook = await practicesService.create(pbPayload);
         dispatch.lifeCycle.setPlaybook({...playbook});
         dispatch.lifeCycle.setPlaybookGenerationIndex(0)
         dispatch.lifeCycle.setPlaybookGenerationState(null)
         dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": accountId });
        payload.playbook = playbook
        await dispatch.lifeCycle.getPlayBookDescription(payload)
      }catch(e){
        console.error(e);
        dispatch.lifeCycle.setPercentageGenerationComplete(null);
        dispatch.lifeCycle.setPlaybookGenerationIndex(0)
        dispatch.lifeCycle.setPlaybookGenerationState(null)
        dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": accountId });
      }
    },
    async getPlayBookDescription(payload,state){
      if(payload.playbook.playbookGenerationStatus !== 0){
        const updatePayload = {
          '$set': {
            playbookGenerationStatus: 0
          },
          '$unset': {
            generativeLogs: ""
          }
        };
        await practicesService.patch(payload.playbook._id,updatePayload)
      }
      payload.organizationId = payload.playbook.organizationId
      payload.accountId = payload.playbook.accountId
      await dataProcessorDescriptionService.find({query:{...payload}});
    }, 
    async getPlaybookImages(payload,state){
      const resImageArray = await dataProcessorImageService.find({query:payload});
      dispatch.lifeCycle.setPlaybookImagesBuffer(resImageArray)
   },
   async getLeafNodeActivities(payload,state){
    payload.metaData = payload.metaData || {};
    payload.metaData.generateActivitiesInProgress = true;
    await dispatch.lifeCycle.updatePlaybookActivities(payload);
    const tokenString = state.login.accessToken;
    const accountId = state.app.selectedAccount._id;
    const workspaceId = state.app.selectedOrganisation.id;
    const activityMap = new Map();
    const playbook = state.lifeCycle.selectedPracticeLibrary 
    const stages = state.createPack.selectedPracticeFlowActivity;
    let modifiedPlaybookPayload = {
      "playbook_name" : playbook.name,
      "playbook_description": playbook.description
    };
    dispatch.lifeCycle.updatePlaybookBySpecificFields({ _id: playbook._id, playbookGenerationStatus: 1 });
    // let generatedPayload = playbook.metaData
    if(stages.activities && stages.activities.length > 0){
      while (stages.activities.length > 0) {
        await activitiesService.remove(stages.activities[0]);
          stages.activities.splice(0, 1);
      }
    }
    let beforeCurrentStagesStr = "";
    let afterCurrentStagesStr = "";
    let isCurrentStageReached = false;

        for (let [i, phase] of playbook.activities.entries()) {
          if (!modifiedPlaybookPayload.phases) {
            modifiedPlaybookPayload.phases = [];
          }
          modifiedPlaybookPayload.phases[i] = {
            phase_name: phase.name,
            "accountable_role": playbook.communities[0].communities
              .filter(role => phase.raci.a == role._id)
              .map(role => role.name)[0],
            "responsible_roles": playbook.communities[0].communities
              .filter(role => phase.raci.r.includes(role._id))
              .map(role => role.name),
            stages: []
          };
          for (let [j, stage] of phase.activities.entries()) {
            if (stage.name === stages.name) {
              isCurrentStageReached = true;
            } else {
              if (!isCurrentStageReached) {
                beforeCurrentStagesStr = `${beforeCurrentStagesStr}, ${phase.name}-${stage.name}`;
              } else {
                afterCurrentStagesStr = `${afterCurrentStagesStr}, ${phase.name}-${stage.name}`;
              }
            }
            modifiedPlaybookPayload.phases[i].stages[j] = {
              stage_name: stage.name,
              "accountable_role": playbook.communities[0].communities
                .filter(role => stage.raci.a == role._id)
                .map(role => role.name)[0],
              "responsible_roles": playbook.communities[0].communities
                .filter(role => stage.raci.r.includes(role._id))
                .map(role => role.name),
              activities: []
            };
            for (let [k, activity] of stage.activities.entries()) {
              modifiedPlaybookPayload.phases[i].stages[j].activities[k] = {
                activity_name: activity.name,
                "accountable_role": playbook.communities[0].communities
                .filter(role => activity.raci.a == role._id)
                .map(role => role.name)[0],
                "responsible_roles": playbook.communities[0].communities
                  .filter(role => activity.raci.r.includes(role._id))
                  .map(role => role.name),
              };
            }
          }
        }
        let stageCompletionPercentage =  100;
        let overallCompletionPrecentage = 0;
          if(!(stages.activities && stages.activities.length > 0)){
          const currentStage = stages;
          const query = {
            beforeCurrentStagesStr : beforeCurrentStagesStr,
            afterCurrentStagesStr : afterCurrentStagesStr,
            playbook : modifiedPlaybookPayload,
            playbook_id: currentStage.packId,
            stage_id: currentStage._id,
            phase_name: currentStage.parentActivity.name,
            stage_name: currentStage.name,
          }
          dataProcessorLeafNodeActivitiesService.find({query:query});
          // let activityCompletionPercentage = stageCompletionPercentage/result.tasks.length;
          // const activities = [];
          // for (let taskIndex = 0; taskIndex < result.tasks.length; taskIndex++) {
          //   const parentActivity = currentStage;
          //   const newActivity = {
          //     name: result.tasks[taskIndex],
          //     description: result.tasks[taskIndex],
          //     packId: parentActivity.packId,
          //     branchID: parentActivity.branchID,
          //     parentActivity: parentActivity._id,
          //     isLeafNode: true,
          //     isParentNode: false,
          //     isMilestone: false,
          //     accountId: parentActivity.accountId,
          //     organizationId: parentActivity.organizationId,
          //     lastUpdatedBy: state.app.user._id.toString(),
          //     createdBy: state.app.user._id.toString(),
          //     metaData: {
          //     }
          //   }
          //   const leafActivity = await activitiesService.create(newActivity);
          //   activityMap.set(leafActivity._id, leafActivity);
          //   activities.push(leafActivity);
          //   overallCompletionPrecentage = (taskIndex+1)*activityCompletionPercentage
          //   dispatch.lifeCycle.setPercentageGenerationComplete(overallCompletionPrecentage.toFixed(2));
          // }
          // playbook.totalLeafActivities = playbook.totalLeafActivities + activities.length;
          // currentStage.activities = activities;
          // playbook.stages = stages;
          // playbook.activityMap = activityMap;
          // dispatch.lifeCycle.setPlaybook({...playbook});
        }
        // dispatch.lifeCycle.setPercentageGenerationComplete(null);
   },
   async webSearch(payload,state) {
    const tokenString = state.login.accessToken
    const accountId = state.app.selectedAccount._id;
    const workspaceId = state.app.selectedOrganisation.id;
    const playbook = state.lifeCycle.selectedPracticeLibrary;
    let topic = playbook.genParams.find((params)=>params.key === 'topic');
    let playbookNameStr = `${topic.value} `;
    playbook.genParams && playbook.genParams.length > 0 && playbook.genParams.forEach((attr, index) => {
      if (index !== 0 && attr.key !== 'topic') {
        const attrStr = `${attr.key} : ${attr.value}`;
        playbookNameStr = `${playbookNameStr}, ${attrStr}`
      }
    })

    const selectedActivity = state.createPack.selectedPracticeFlowActivity
    const updatingActivity = await activitiesService.patch(selectedActivity._id, { 
      $set: { aiGenStatus: 0, metaData:{}, attachments:[] },
     })
    selectedActivity.aiGenStatus = updatingActivity.aiGenStatus;
    selectedActivity.metaData = updatingActivity.metaData;
    selectedActivity.attachments = updatingActivity.attachments;
    let selectedStage = {}
    playbook.activities.forEach((phase)=>{
      phase.activities.forEach((stage)=>{
        if(stage._id === selectedActivity.parentActivity._id){
          selectedStage = stage;
        }
      })
    })

    const stageChildren = selectedStage.activities;

    const completedActivityNames = [];
    for (let i = 0; i < stageChildren.length; i++) {
      const activity = stageChildren[i];
      if (activity._id == selectedActivity._id) {
        break;
      } else {
        completedActivityNames.push(activity.name);
      }
    }
    try {
      const query = {
        completedActivityNames :  completedActivityNames,
        playbook : playbook,
        selectedStage : selectedStage,
        selectedActivity : selectedActivity,
        playbookNameStr : playbookNameStr,
        organisationId : workspaceId,
      }

      let webSearchResult = await dataProcessorWebSearchService.find({query:query});
      // const rolesRes = await dataProcessorActivitiesService.find({query:query})
      // const roleMap = new Map();
      // if (rolesRes) {
      //   const responsibilityKeys = Object.keys(rolesRes);
      //   const processRoleData = function (resKey, roleInfo) {
      //     const resArray = roleMap.get(roleInfo.name);
      //     if (!resArray) {
      //       roleMap.set(roleInfo.name, [resKey]);
      //     } else {
      //       resArray.push(resKey)
      //     }
      //   }
      //   responsibilityKeys.forEach((resKey) => {
      //     if (Array.isArray(rolesRes[resKey])) {
      //       rolesRes[resKey].forEach((data) => {
      //         processRoleData(resKey, data)
      //       })
      //     } else {
      //       processRoleData(resKey, rolesRes[resKey])
      //     }
      //   })
      // }

      if (selectedActivity) {
        const referenceLinks = webSearchResult.retrievedUrls.map((elem) => {
          return ({
            // "id": generateObjectId(),
            "documentName": elem.title.replace('/', ''),
            "documentId": generateObjectId(),
            "documentUrl": elem.link,
            "uploadedBy": state.app.user._id.toString(),
            "uploadedAt": new Date()

          })
        });
        const metaDataSchema = {
          title:"Checklist",
          name:"checklist",
          type:"checkbox",
          choices:[],
          isRequired:true,
          metaData:{}

        }
        for(let step of webSearchResult.answer.steps){
          metaDataSchema.choices.push(step.name);
        }
        const updatedActivity = await activitiesService.patch(selectedActivity._id, {
          aiGenStatus: 1,
          attachments: referenceLinks,
          metaData: {
            steps: webSearchResult.answer.steps,
            isComplete: true,
         //   raci: rolesRes
          },
          metaDataSchema:[metaDataSchema]
        })

        selectedActivity.aiGenStatus = updatedActivity.aiGenStatus;
        selectedActivity.metaData = updatedActivity.metaData;
        selectedActivity.attachments = updatedActivity.attachments;
       // selectedActivity.metaData.roleMap  = roleMap;
      }
    } catch (e) {
      console.error(e);
      const updatingErrorActivity = await activitiesService.patch(selectedActivity._id, { 
        $set: { aiGenStatus: -1 },
       })
       selectedActivity.aiGenStatus = updatingErrorActivity.aiGenStatus
    }
  },
  async generateDetailsOfSingleLeafNodeActivity(payload,state) {
    payload.metaData = payload.metaData || {};
    payload.metaData.generateActivityDetailsInProgress = true;
    await dispatch.lifeCycle.updatePlaybookActivities(payload);
    let playbook;
    if(payload && payload.playbook){
      playbook = payload.playbook;
    } else {
      playbook = state.lifeCycle.selectedPracticeLibrary;
    }
      await dispatch.lifeCycle.updatePlaybookBySpecificFields({ _id: playbook._id, playbookGenerationStatus: 1 });
      const generatingActivities = payload.generatingActivities;
      await activitiesService.patch(
        null,
        { 
          $set: { aiGenStatus: 0, attachments: [] }
        },
        {
          query: {
            _id: { $in: generatingActivities }
          }
        }
      );
      const workspaceId = state.app.selectedOrganisation.id;
      let topic = playbook.genParams.find((params)=>params.key === 'topic');
      let playbookNameStr = `${topic.value} `;
      playbook.genParams && playbook.genParams.length > 0 && playbook.genParams.forEach((attr, index) => {
        if (index !== 0 && attr.key !== 'topic') {
          const attrStr = `${attr.key} : ${attr.value}`;
          playbookNameStr = `${playbookNameStr}, ${attrStr}`
        }
      })
      try {
        const allWebSearchPayload = {
          playbook : playbook,
          playbookNameStr : playbookNameStr,
          organisationId : workspaceId,
          generatingActivities:generatingActivities
        }
        if(playbook && playbook.genParams && playbook.genParams.length > 0){
          let roleObject = playbook.genParams.filter((param)=>{return param.key == 'Role'})[0];
          allWebSearchPayload.userRole = roleObject.value;
        }
        await dataProcessorAllWebSearchService.create(allWebSearchPayload);
      } catch (e) {
        console.error(e);
      }
  },
  async allActivitiesWebSearch(payload,state) {
    let playbook;
    if(payload && payload.playbook){
      playbook = payload.playbook;
    } else {
      playbook = state.lifeCycle.selectedPracticeLibrary;
    }
    if(playbook && (playbook.playbookGenerationStatus === 0 || playbook.playbookGenerationStatus === 2 || payload.activityGenerationAttempt === 2)){
      playbook.playbookGenerationStatus = 1;
      const generatingActivities = [];
      for (let phase of playbook.activities) {
        for (let stage of phase.activities) {
            if(payload && payload.stageIds){
                let stageId = payload.stageIds.find(id => id === stage._id)
                if(!stageId){
                    continue;
                }
            }
            for (let activity of stage.activities) {
              if(payload && payload.activityIds){
                let activityId = payload.activityIds.find(id => id === activity._id)
                if(activityId){
                  generatingActivities.push(activityId);
                }
              }else if(payload && payload.type === "error" && activity.aiGenStatus && activity.aiGenStatus === -1){
                generatingActivities.push(activity._id);
              } else if(!payload || !payload.type || payload.type !== "error"){
                generatingActivities.push(activity._id);
              }
            }
        }
      }
    await activitiesService.patch(
      null,
      { 
        $set: { aiGenStatus: 0, metaData: {}, attachments: [] }
      },
      {
        query: {
          _id: { $in: generatingActivities }
        }
      }
    );
      const updatedPlaybook = await practicesService.patch(
        playbook._id,
        {
          $set: {playbookGenerationStatus : 1, generatingActivities,"generativeLogs.activityGenerationAttempt" : payload && payload.activityGenerationAttempt ? payload.activityGenerationAttempt : 1},
          accountId: playbook.accountId,
          organizationId:
            playbook.organizationId,
        },
        {
          query: {
            $populate: [
              {
                path: "participants.accountUserId",
                populate: "accountUserId",
                select: "_id firstName lastName profilePic email",
              },
              {
                path: "notes.accountUserId",
                populate: "accountUserId",
                select: "_id firstName lastName profilePic email ",
              },
              {
                path: "attachments.uploadedBy",
                populate: "uploadedBy",
                select: "_id firstName lastName profilePic ",
              },
              {
                path: "baseCategory",
                populate: "baseCategory",
                select: "_id name",
              },
              { path: "category", populate: "category", select: "_id name" },
              {
                path: "subCategory",
                populate: "subCategory",
                select: "_id name",
              },
            ],
          },
        }
      );
      await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(updatedPlaybook._id);
      const workspaceId = state.app.selectedOrganisation.id;
      let topic = playbook.genParams.find((params)=>params.key === 'topic');
      let playbookNameStr = `${topic.value} `;
      playbook.genParams && playbook.genParams.length > 0 && playbook.genParams.forEach((attr, index) => {
        if (index !== 0 && attr.key !== 'topic') {
          const attrStr = `${attr.key} : ${attr.value}`;
          playbookNameStr = `${playbookNameStr}, ${attrStr}`
        }
      })
      try {
        const allWebSearchPayload = {
          playbook : playbook,
          playbookNameStr : playbookNameStr,
          organisationId : workspaceId,
          generatingActivities:generatingActivities
        }
        if(playbook && playbook.genParams && playbook.genParams.length > 0){
          let roleObject = playbook.genParams.filter((param)=>{return param.key == 'Role'})[0];
          allWebSearchPayload.userRole = roleObject.value;
        }
        if(payload && payload.stageIds){
          allWebSearchPayload.stageIds = payload.stageIds
        };
        dataProcessorAllWebSearchService.create(allWebSearchPayload)
      await dispatch.lifeCycle.getActivitiesCompletionPercentage();
      } catch (e) {
        console.error(e);
      }
    }
  },
  async getActivitiesCompletionPercentage(payload,state){
    let playbook;
    if(payload){ 
      playbook = await practicesService.get(payload, {
        query: {
          $populate: [
            {
              path: "participants.accountUserId",
              populate: "accountUserId",
              select: "_id firstName lastName profilePic email",
            },
            {
              path: "notes.accountUserId",
              populate: "accountUserId",
              select: "_id firstName lastName profilePic email ",
            },
            {
              path: "attachments.uploadedBy",
              populate: "uploadedBy",
              select: "_id firstName lastName profilePic ",
            },
            {
              path: "baseCategory",
              populate: "baseCategory",
              select: "_id, name",
            },
            { path: "category", populate: "category", select: "_id, name" },
            {
              path: "subCategory",
              populate: "subCategory",
              select: "_id, name",
            },
            { path: "teamId", model: "suborganizations", select: "name" },
          ],
        },
      });
    } else {
       playbook = state.lifeCycle.selectedPracticeLibrary;
    }
    let activityGenerated = 0;
    if(playbook 
      && typeof playbook.playbookGenerationStatus !== 'undefined'
      && playbook.playbookGenerationStatus === 1  
			&& playbook.genParams 
			&& playbook.genParams.length > 0 && playbook.generatingActivities && playbook.generatingActivities.length > 0){
        let totalActivities = playbook.generatingActivities.length 
        let errorActivities = [];
        for (let phase of playbook.activities) { 
          for (let stage of phase.activities) {
            for (let activity of stage.activities) {
              let isGeneratingActivity = playbook.generatingActivities.some(id => id === activity._id);
              if ('aiGenStatus' in activity && activity.aiGenStatus !== 0 && isGeneratingActivity) {
                  activityGenerated++;
              }
              if ('aiGenStatus' in activity && activity.aiGenStatus === -1 && isGeneratingActivity) {
                errorActivities.push(activity._id);
            }
            }
          }
        }
        const completionPercentage = (activityGenerated / totalActivities) * 100;
        if(completionPercentage < 100) {
          playbook.percentageActivitesGenerated = completionPercentage.toFixed(2);
          dispatch.lifeCycle.setSelectedPracticeLibrary(playbook);
          // dispatch.lifeCycle.setPercentageActivitiesGenerated(completionPercentage.toFixed(2));
        } else if(playbook && playbook.generativeLogs && playbook.generativeLogs.activityGenerationAttempt === 1 && errorActivities.length > 0){
          const webSearchPayload = {
            playbook,
            activityGenerationAttempt:2,
            activityIds:errorActivities,
          }
          await dispatch.lifeCycle.allActivitiesWebSearch(webSearchPayload)
        }else {
          // dispatch.lifeCycle.setPercentageActivitiesGenerated(null);
          if(playbook && playbook.playbookGenerationStatus !== 2){
            playbook.playbookGenerationStatus = 1;
            const updatedPlaybook = await practicesService.patch(
              playbook._id,
              {
                $set: {playbookGenerationStatus : 2},
                $unset: {generatingActivities : 0},
                accountId: playbook.accountId,
                organizationId:
                  playbook.organizationId,
              },
              {
                query: {
                  $populate: [
                    {
                      path: "participants.accountUserId",
                      populate: "accountUserId",
                      select: "_id firstName lastName profilePic email",
                    },
                    {
                      path: "notes.accountUserId",
                      populate: "accountUserId",
                      select: "_id firstName lastName profilePic email ",
                    },
                    {
                      path: "attachments.uploadedBy",
                      populate: "uploadedBy",
                      select: "_id firstName lastName profilePic ",
                    },
                    {
                      path: "baseCategory",
                      populate: "baseCategory",
                      select: "_id name",
                    },
                    { path: "category", populate: "category", select: "_id name" },
                    {
                      path: "subCategory",
                      populate: "subCategory",
                      select: "_id name",
                    },
                  ],
                },
              }
            );
            if(state.lifeCycle.selectedPracticeLibrary._id === playbook._id) {
               await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(playbook._id);
            }
          }
      }
    }
  },
  async configureActivityActions(payload, state){
    let activityActions = await activityActionsService.create(payload);
    dispatch.createPack.getSelectedActivityActions(payload.activityId);
  },
  async updateActivityActions(payload, state){
    let activityActions = await activityActionsService.patch(payload._id, payload);
    dispatch.createPack.getSelectedActivityActions(payload.activityId);
  },
  async deleteActivityActions(payload, state){
    let activityActions = await activityActionsService.remove(payload._id);
    dispatch.createPack.getSelectedActivityActions(payload.activityId);
  },
  async deleteAllActivityActionsForId(payload, state){
      let params = {
        "query": {
          "activityId": payload._id
        }
      }
      activityActionsService.remove(null, params);
    dispatch.createPack.getSelectedActivityActions(payload._id);
  },
  async fetchCustomTemplates(payload, state, activityActions) {
    let query = {
        "type": { "$ne": "globalHeader" }
    };
    try {
        // Fetch templates
        let templates = await customTemplateActionService.find({ query: query });
        let data = [];
        // reset Data if isSmartActivity is true
        if (payload.isSmartActivity) {
            data = templates.data.map((template) => ({
              "_id": template._id,
              "key": template._id,
              "text": template.name,
              "value": template._id
          }));
      } else {
        // Check if templates and activityActions are valid
        if (templates && Array.isArray(templates.data) && templates.data.length > 0) {
            if (activityActions && Array.isArray(activityActions) && activityActions.length > 0) {
                for (let template of templates.data) {
                      // Only filter out templates used in actions with the same processingType
                    let foundAction = activityActions.find((action) => 
                      action.metaData && 
                      action.metaData.templateId && 
                      template._id.toString() === action.metaData.templateId.toString() && action.processingType === payload.processingType  // Add this condition
                    );
                    // If no matching action is found, push template to data
                    if (!foundAction) {
                        data.push({
                            "_id": template._id,
                            "key": template._id,
                            "text": template.name,
                            "value": template._id
                        });
                    }
                }
            } else {
                // If there are no activityActions, add all templates to data
                    data = templates.data.map((template) => ({
                        "_id": template._id,
                        "key": template._id,
                        "text": template.name,
                        "value": template._id
                    }));
            }
        }
      }
        // Dispatch the custom email templates data
        dispatch.lifeCycle.setCustomEmailTemplates(data);
    } catch (error) {
        console.error("Error fetching custom templates:", error);
        // Optionally: Dispatch an error or handle it as necessary
    }
  },
  async fetchMakeScenarios(payload, state) {
    try {
      // Fetch scenarios
      let activityActions = payload.activityActions;
      let processingType = payload.processingType;
      let scenarios = await makeAllScenariosService.find();
      let data = [];
        // Check if scenarios and activityActions are valid
        if (Array.isArray(scenarios) && scenarios.length > 0) {
            if (activityActions && Array.isArray(activityActions) && activityActions.length > 0) {
                for (let scenario of scenarios) {
                    let foundAction = activityActions.find((action) => ((action.metaData.scenarioId && (scenario.id).toString() === (action.metaData.scenarioId).toString()) && action.processingType === processingType));
                    // If no matching action is found, push scenario to data
                    if (!foundAction) {
                        data.push({
                          "_id": scenario.id,
                          "key": scenario.id,
                          "text": scenario.name,
                          "value": scenario.id
                        });
                    }
                }
            } else {
                // If there are no activityActions, add all scenarios to data
                for (let scenario of scenarios) {
                    data.push({
                        "_id": scenario.id,
                        "key": scenario.id,
                        "text": scenario.name,
                        "value": scenario.id
                    });
                }
            }
            dispatch.lifeCycle.setMakeScenarios(data);
        }
    } catch (error) {
      console.error("Error fetching make scenarios: ", error);
    }
  },
  async fetchScenarioInputs(payload, state){
    try {
      let senarioInputs = await GetScenarioInputs.find({"query": payload});
      dispatch.lifeCycle.setScenarioInputs(senarioInputs);
    } catch (error) {
      console.log("Error while fetching scenario inputs ",error);
    }
  },
  async getTeamsUnderManager(payload, state) {
    const getTeamDropdown = function (orgUnits, teamArr, parent) {
      if (orgUnits) {
        for (const unit of orgUnits) {
          let teamName = parent ? parent + " > " + unit.label : unit.label;
          teamArr.push({ text: teamName, value: unit._id });
          if (unit.nodes) {
            getTeamDropdown(unit.nodes, teamArr, teamName);
          }
        }
        return teamArr;
      }
    };
    try {
      const orgUnits = await subOrganizationTreeService.get(payload.id);
      if (payload.teamlist === true) {
        let teamArr = [];
        let selectItem = {
          text: "Search Team",
          value: null,
        };
        let teamList = getTeamDropdown(orgUnits, teamArr, "");
        teamList.unshift(selectItem);
        dispatch.lifeCycle.setTeamList(teamList);
        return teamList;
      }
    } catch (err) {
      throw err;
    }
  },
  async getEntityFieldMapping(payload, state){
    try {
      let entityFieldMapping = await entityFieldMappingService.find({});
      if(entityFieldMapping && entityFieldMapping.data && entityFieldMapping.data.length>0){
        dispatch.lifeCycle.setEntityFieldMapping(entityFieldMapping.data);
        let entities = [];
        for(let mapping of entityFieldMapping.data){
          entities.push({
            "name": mapping.EntityName,
            "id": mapping.id,
            "key": mapping.id,
            "text": mapping.EntityName,
            "value": mapping.collectionName
          });
        }
        dispatch.lifeCycle.setMakeEntities(entities);
      }
    } catch (error) {
      console.log("error while fetching entityFieldMapping ",error);
    }
  },
  async updateActivityStatus(payload, state) {
    try {
        const activity = await activitiesService.get(payload.id);
        // console.log("activity",activity)
        if (activity) {
            activity.isActivityDisabled = payload.isActivityDisabled;

            const updatedActivity = await activitiesService.patch(payload.id, activity);
            return updatedActivity;
        }
        const updatedActivity = await activitiesService.get(payload.id);

        
    } catch (error) {
        console.error("Error updating activity status:", error);
        throw error;
    }
}

  },
};